/* ------------------------------------------ GRYFF ELEMENT - Chris 04.07.2016 ----------------------------------------- */
import HELPER, { copyToClipboard, initAce } from '@/app/utils/HELPER';
import utils from '@/app/utils/gfUtils';
import atom from '@/app/editor/iframe/atom';
import store from '@/app/store/store';
import replaceImageToSize, { hasImageShopify } from '@/app/utils/replaceImageToSize';
import hasImageUploadCare from '@/app/utils/hasImageUploadCare';
import { getFileExtensionFromSource, initSizeForElement, replaceQuoteCharacter } from '@/app/utils/helpers';
import autoFixImportantCss from '@/app/utils/autoFixImportantCss';
import elementsInfo from '@/app/editor/sidebar/elementsInfo';
import { validateInput } from '@/app/editor/sidebar/utils/validateInput.ts';
import storeX, { app } from '@/store';
import { mutations } from '@modules/libraries/store/types';
import { checkKeyValid } from '@/app/utils/checkRoleApply.ts';
import { elementTypes, base, SCROLL_VIEW_KEY, SHOP_LOCALE_URL } from './constant';
import { setFontWeight, getFontWeightDesignOption } from '@/app/utils/settingFontWeight';
import { getKeyFromModuleName } from '@/app/utils/moduleKeyName';
import { renderTabSettings } from '@/app/editor/sidebar/global-style/renderTabSetting';
import { handleModifyItemStyle } from '@/utils/apply-preset';
import emitter from '@/emitter';
import { renderFontList } from '@/app/editor/sidebar/utils/fontPicker';
import { handleAddToLibrary } from './utils/validateAddToLibrary';
import { removeElement, isLandingPage } from '@/modules/gem-meter';
import { EDITOR_EVENT } from '@/app/editor/config/constants/trackEventIds';

(function (jQuery) {
  jQuery.gfElement = function (element, options) {
    const defaults = {};
    this.settings = {};
    const _this = this;
    const $element = jQuery(element);

    // updated stuffs
    const _mdEditor =
      '<div id="md-editor" class="md-modal md-draggable">' +
      '<div class="md-content">' +
      '<div class="md-modal-handle">' +
      '<span class="md-title">' +
      '<span gf-tag="title">Code Editor</span>' +
      '<span gf-tag="type" gf-action="click:copyToClipboard" title="Click to copy"></span>' +
      '</span>' +
      '</div>' +
      '<div class="md-body code-panel">' +
      '<div class="section" gf-tabs="coding">' +
      '<div class="section-item disabled" gf-tab="template">Template</div>' +
      '<div class="section-item disabled" gf-tab="style">CSS</div>' +
      '</div>' +
      '<textarea id="templateCode" class="inptxt"></textarea>' +
      '<textarea id="styleCode" class="inptxt"></textarea>' +
      '</div>' +
      '<div class="md-footer">' +
      '<button class="btnSave">Save</button>' +
      '<button class="btnCancel" class="cancel">Cancel</button>' +
      '</div>' +
      '</div>' +
      '<div class="md-controls">' +
      '<button class="btnClose"><i class="fa fa-times" aria-hidden="true"></i></button>' +
      '</div>' +
      '</div>';

    const {
      buttonInfo,
      headingInfo,
      textBlockInfo,
      submitButtonInfo,
      iconInfo,
      imageInfo,
      separatorInfo,
      textFieldInfo,
      emailFieldInfo,
      textareaInfo,
      dropdownInfo,
      checkboxInfo,
    } = elementsInfo;
    const elementInfo = [
      buttonInfo,
      headingInfo,
      textBlockInfo,
      submitButtonInfo,
      iconInfo,
      imageInfo,
      separatorInfo,
      textFieldInfo,
      emailFieldInfo,
      textareaInfo,
      dropdownInfo,
      checkboxInfo,
    ];

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $gfResTool = jQuery('#gfResTool');
    const $divContentHidden = jQuery('#divContentHidden');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();
    const $divContentBk = $gfFrame.contents().find('#divContentBk');

    /* Style */
    const $elementStyleContainer = $gfFrame.contents().find('#' + elementTypes._elementStyleContainer);

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      const label = _this.getElementName();

      if (label !== '') {
        const elementId = _this.getElementId();
        let existingContent = '';

        let isInitNewElement = false;
        const key = HELPER.getKeyDataSetting(base._snippet, elementId, 'element');
        const elmData = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](key);
        if (!elmData) {
          isInitNewElement = true;
          let $snippet;
          const storeSnippet = app.$store.getters['editor/GET_SNIPPETS_BY_KEY'](_this.getElementKey());
          if (_this.settings.snippet) {
            $snippet = jQuery(_this.settings.snippet);
          } else {
            $snippet = jQuery('<div />').html(storeSnippet).children();
            existingContent = $element.html();
          }

          const snippet = $snippet.html();
          const icon = $snippet.attr('data-icon') ? $snippet.attr('data-icon') : 'images/icons/default.png';
          const ver = $snippet.attr('data-ver') ? $snippet.attr('data-ver') : '1';
          const formField = $snippet.attr('data-form') ? $snippet.attr('data-form') : '';
          _this.initWithSnippet(label, elementId, icon, ver, snippet, formField, existingContent);
        }

        _this.initDataEditorInfo();
        _this.refresh();

        if (!_this.settings.isClone) {
          _this.afterRefreshInitClassGs(isInitNewElement);
        }

        // ===== GemMeter Feature ===== //
        const __countElement = () => {
          if (window.__countElement === 0) {
            storeX.state.editor.loadFinishALLMER = true;
          } else {
            window.__countElement = window.__countElement - 1;
          }
        };
        if (isLandingPage()) {
          __countElement();
        }
        // =========================== //
      } else {
        return false;
      }
    };
    this.initDataEditorInfo = function () {
      const isExistEditorInfo = app.$store.getters['editor/EXIST_KEY_DATA_SETTING'](this.getElementId());

      if (isExistEditorInfo) return;
      const dataEditorInfo = {};
      dataEditorInfo.id = this.getElementId();
      dataEditorInfo.merId = this.getElementTargetId();
      dataEditorInfo.key = this.getElementKey();
      dataEditorInfo.label = this.getElementName();
      dataEditorInfo.data = {
        globalStyle: [],
      };

      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: this.getElementId(),
        value: JSON.stringify(dataEditorInfo),
      });

      emitter.emit('store:add-snippet-finish', {
        key: dataEditorInfo.key,
        id: dataEditorInfo.merId,
      });
    };

    this.afterRefreshInitClassGs = function (isInitNewElement) {
      const merKey = _this.getElementKey();
      const merId = _this.getElementTargetId();
      const paramInitClass = {
        mer: $element,
        type: merKey,
        merId: merId,
        merType: 'element',
        isInitMER: true,
        isUpdateClassInDom: true,
      };
      renderTabSettings.initGlobalStyleClass(paramInitClass);
      if (!isInitNewElement) {
        // Improve Perform: Nếu không phải case kéo mới thì mới modify style
        const keyStyle = HELPER.getKeyDataSetting(base._style, _this.getElementId(), 'element');
        const preset = app.$store.getters['sidebar/getPresetByPagePresetId'];
        if (preset && Object.keys(preset).length) {
          handleModifyItemStyle({ keyStyle, merKey, merId });
        }
      }
      return false;
    };

    this.initWithSnippet = function (label, elementId, icon, ver, snippet, formField, existingContent) {
      $element
        .attr('id', 'e-' + elementId)
        .addClass('element-wrap')
        .attr('data-label', label)
        .attr('data-icon', icon)
        .attr('data-ver', ver)
        .attr('data-id', elementId);

      if (formField) {
        $element.attr('data-form', formField);
      }

      const $snippet = jQuery('<div/>').html(snippet);
      const $template = $snippet.find('.template');
      const $style = $snippet.find('.style');

      let style = $style.html();
      if (style) {
        style = style.replace(/{{(\S*\s+)?element-id(\S*\s+)?}}/g, elementId);
        style = HELPER.formatCSS(style);
        $style.html('');
        $style.html(style);
      }

      let html = '';
      if (existingContent !== '') {
        html = existingContent;
      } else {
        html = $template.html();
      }

      $element.html(html);
      const $toModule = $element.closest('.module-wrap');

      if (formField && !$element.find('.elm').find('input, textarea, select').attr('name')) {
        if ($toModule.length && $toModule.attr('data-label') === 'Contact Form') {
          if ($element.find('.elm input[type="email"]').length) {
            $element.find('.elm input[type="email"]').attr('name', 'contact[email]').val('contact[email]');
            $element.find('.elm input[type="email"]').removeAttr('readonly');
            $element.find('.elm input[type="email"]').removeAttr('data-description');
          } else {
            $element
              .find('.elm')
              .find('input, textarea, select')
              .attr('name', 'contact[field-' + HELPER.MakeId() + ']');
          }
        } else if ($toModule.length && $toModule.attr('data-label') === 'Newsletter') {
          if ($element.find('.elm input[type="email"]').length) {
            $element.find('.elm input[type="email"]').attr('name', 'email').val('email');
            $element.find('.elm input[type="email"]').removeAttr('readonly');
            $element.find('.elm input[type="email"]').removeAttr('data-description');
          } else {
            $element
              .find('.elm')
              .find('input, textarea, select, button')
              .attr('name', 'field-' + HELPER.MakeId());
          }
        } else {
          if (
            $toModule.length &&
            $toModule.attr('data-label') === 'Mailchimp' &&
            $element.find('.elm input[type="email"]').length
          ) {
            $element.find('.elm input[type="email"]').attr('name', 'email').val('email');
            $element.find('.elm input[type="email"]').removeAttr('readonly');
            $element.find('.elm input[type="email"]').removeAttr('data-description');
          } else {
            $element
              .find('.elm')
              .find('input, textarea, select, button')
              .attr('name', 'field-' + HELPER.MakeId());
          }
        }
      }

      //$template.remove(); // auto remove template
      HELPER.addContentBk('<div id="element-' + elementId + '">' + $snippet.html() + '</div>');
      return false;
    };

    this.refresh = function (type) {
      _this.applyEvents();
      _this.applyDrag();
      _this.runStyle();

      HELPER.generatePlaceholderForm($element);
      return false;
    };

    this.runStyle = function (style) {
      if (!style) {
        style = this.getElementCSSUseStore();
      }
      if (checkKeyValid('autoFixImportantCss')) {
        const label = _this.getElementName();
        const hasUsed = ['Heading', 'Text Block'];
        if (hasUsed.includes(label)) {
          style = autoFixImportantCss(style);
        }
      }
      return this.setElementCSSUseStore(style);
    };

    this.getElementKey = function () {
      const key = $element.attr('data-key');
      if (key) {
        return key;
      } else {
        const name = _this.getElementName();
        return getKeyFromModuleName(name);
      }
    };

    this.getElementId = function () {
      let elementId = HELPER.MakeIdInsideList($element);
      if (elementId === '') {
        elementId = $element.attr('data-id') || HELPER.MakeId();
      }
      return elementId;
    };

    this.getElementTargetId = function () {
      return `#e-${_this.getElementId()}`;
    };

    this.getElementName = function () {
      return $element.attr('data-label') || '';
    };

    this.getElementIcon = function () {
      return $element.attr('data-icon') || '';
    };

    this.getTargetClass = function () {
      let targetClass = '';
      for (let i = 0; i < elementInfo.length; i++) {
        let elementClass = jQuery.trim(elementInfo[i]['class']);
        if (elementClass !== '') {
          elementClass = '.' + elementClass;
          if ($element.find(elementClass).length > 0) {
            targetClass = elementClass;
            break;
          }
        }
      }
      return targetClass;
    };

    this.getElementCSS = function () {
      return this.getElementCSSUseStore();
    };

    this.getElementCSSUseDom = function () {
      let style;
      const elementId = this.getElementId();
      const $bkActiveElement = $divContentBk.find('#element-' + elementId);
      const $style = $bkActiveElement.children('.style');

      if ($style) {
        $style.attr('type', 'text/plain');
        style = $style.html();
        $style.attr('type', 'text/css');
      } else {
        style = '';
      }
      return style;
    };

    this.getElementCSSUseStore = function () {
      const elementId = this.getElementId();
      const key = 'style-element-' + elementId;
      return app.$store.getters['editor/GET_DATA_SETTING_BY_KEY'](key);
    };

    this.setElementCSS = function (style) {
      return this.setElementCSSUseStore(style);
    };

    this.setElementCSSUseDom = function (style) {
      style = HELPER.formatCSS(style);
      const elementId = this.getElementId();
      const $bkActiveElement = $divContentBk.find('#element-' + elementId);

      const $style = $bkActiveElement.children('.style');
      if ($style) {
        $style.html(style);
      } else {
        jQuery('<style class="style">' + style + '</style>').appendTo($bkActiveElement);
      }

      return _this;
    };

    this.setElementCSSUseStore = function (style) {
      const _style = HELPER.formatCSS(style);
      const elmId = this.getElementId();
      let $thisElmActive = $elementStyleContainer.find('#' + base._style + '-' + elmId);

      if ($thisElmActive.length === 0) {
        $thisElmActive = jQuery(`<div id="${base._style}-${elmId}"></div>`);
        $thisElmActive.appendTo($elementStyleContainer);
      }

      $thisElmActive.html('<style class="style">' + _style + '</style>');
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: elementTypes._styleElement + '-' + elmId,
        value: _style,
      });

      return _this;
    };

    this.getElementTemplateUseStore = function () {
      const elementId = this.getElementId();
      let template = app.$store.getters['editor/GET_DATA_SETTING_BY_KEY']('template-element-' + elementId);
      template = jQuery('<div />').html(template).find('.elm').html();

      return this.formatTemplate(template);
    };

    this.getElementTemplateUseDom = function () {
      const elementId = this.getElementId();
      const $bkActiveElement = $divContentBk.find('#element-' + elementId);
      const $template = $bkActiveElement.find('.template');
      let template = $template.html();
      template = jQuery('<div />').html(template).find('.elm').html();
      template = template.replace(/scri-pt/g, 'script');

      template = HELPER.formatCode(template);
      return template;
    };

    this.getElementTemplate = function () {
      return this.getElementTemplateUseStore();
    };

    this.formatTemplate = (template) => {
      template = template.replace(/scri-pt/g, 'script');
      return HELPER.formatCode(template);
    };

    this.setElementTemplateUseStore = function (template) {
      const elementId = this.getElementId();
      const $bkActiveElement = $divContentBk.find('#element-' + elementId);
      const $template = $bkActiveElement.find('.template');
      // disable script tag in module template
      template = template.replace(/script/g, 'scri-pt');

      // set live
      $element.find('.elm').html(template);
      const parseTpl = `<div class="elm gf-elm-left">${template}</div>`;
      app.$store.commit('editor/SET_DATA_SETTINGS', {
        id: 'template-element-' + elementId,
        value: parseTpl,
      });

      // set bk
      const $templateBk = jQuery('<div>' + $template.html() + '</div>');
      $templateBk.find('.elm').html(template);
      $template.html($templateBk.html());

      _this.refresh();
      return _this;
    };

    this.setElementTemplateUseDom = function (template) {
      const elementId = this.getElementId();

      const $bkActiveElement = $divContentBk.find('#element-' + elementId);
      const $template = $bkActiveElement.find('.template');
      // disable script tag in module template
      template = template.replace(/script/g, 'scri-pt');

      // set live
      $element.find('.elm').html(template);

      // set bk
      const $templateBk = jQuery('<div>' + $template.html() + '</div>');
      $templateBk.find('.elm').html(template);

      $template.html($templateBk.html());

      _this.refresh();
      return _this;
    };

    this.setElementTemplate = function (template) {
      return this.setElementTemplateUseStore(template);
    };

    this.getDynamicHtmlByTemplate = function (template, jsonData) {
      let html = '';

      const tmpl = Liquid.parse(template);
      if (jsonData['product'] != undefined) {
        html = tmpl.render({
          product: jsonData['product'],
        });

        if (jsonData['product']['variants'].length > 0) {
          html = tmpl.render({
            variant: jsonData['product']['variants'][0],
          });
        }
      }
      if (jsonData['article'] != undefined) {
        html = tmpl.render({
          article: jsonData['article'],
        });
      }
      return html;
    };

    this.atTheBottom = function () {
      const $nextBlocks = $element.nextAll('.element-wrap[data-label], .module-wrap[data-label], .gf_row[data-label]');
      return $nextBlocks.length <= 0;
    };

    this.moveDown = function (scrollToMe) {
      if (!_this.atTheBottom()) {
        if (scrollToMe === undefined) {
          scrollToMe = true;
        }

        // update place holder
        const $placeholder = $element.next('.block-placeholder');
        if ($placeholder.length > 0) {
          $placeholder.remove();
        }

        const $nextBlock = $element
          .nextAll('.element-wrap[data-label], .module-wrap[data-label], .gf_row[data-label]')
          .eq(0);
        let $newPlace = $nextBlock.next('.block-placeholder');

        if ($newPlace.length === 0) {
          $newPlace = jQuery('<div class="block-placeholder" />');
          $nextBlock.after($newPlace);
        }

        // History
        let $itemContent;
        let position = {};

        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $element);
        }

        const history = {
          id: $element.attr('id'),
          action: 'move',
          events: [
            {
              action: 'cut',
              position: position,
            },
          ],
        };

        $gryffEditor.trigger('history', history);

        const $from = $element.closest('.item-content');
        const $to = $element.closest('.item-content');

        const $eHandle = $element.children('.gf-tool-wrap').find('.e-handle');
        $eHandle.data('gfdraggable').manageStop($newPlace, $element, $from, $to);

        if (!HELPER.isInsideTheList($element)) {
          if (scrollToMe) {
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $element.offset().top - 80,
              },
              800,
            );
          }
        }
      }
    };

    this.atTheTop = function () {
      const $prevBlocks = $element.prevAll('.element-wrap[data-label], .module-wrap[data-label], .gf_row[data-label]');
      return $prevBlocks.length <= 0;
    };

    this.moveUp = function (scrollToMe) {
      if (!_this.atTheTop()) {
        if (scrollToMe === undefined) {
          scrollToMe = true;
        }

        // update place holder
        const $placeholder = $element.next('.block-placeholder');
        if ($placeholder.length > 0) {
          $placeholder.remove();
        }

        const $prevBlock = $element
          .prevAll('.element-wrap[data-label], .module-wrap[data-label], .gf_row[data-label]')
          .eq(0);
        let $newPlace = $prevBlock.prev('.block-placeholder');

        if ($newPlace.length === 0) {
          $newPlace = jQuery('<div class="block-placeholder" />');
          $prevBlock.before($newPlace);
        }

        // History
        let $itemContent;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $element);
        }

        const history = {
          id: $element.attr('id'),
          action: 'move',
          events: [
            {
              action: 'cut',
              position: position,
            },
          ],
        };

        $gryffEditor.trigger('history', history);
        const $from = $element.closest('.item-content');
        const $to = $element.closest('.item-content');

        const $eHandle = $element.children('.gf-tool-wrap').find('.e-handle');
        $eHandle.data('gfdraggable').manageStop($newPlace, $element, $from, $to);

        if (!HELPER.isInsideTheList($element)) {
          if (scrollToMe) {
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $element.offset().top - 80,
              },
              800,
            );
          }
        }
      }
    };

    this.hasParent = function () {
      const $parent = $element.closest('.module-wrap[data-label], .gf_row[data-label]');
      return $parent.length > 0;
    };

    this.toParent = function (scrollToMe) {
      if (_this.hasParent()) {
        if (scrollToMe == undefined) {
          var scrollToMe = true;
        }

        // update place holder
        const $placeholder = $element.next('.block-placeholder');
        if ($placeholder.length > 0) {
          $placeholder.remove();
        }

        const $parent = $element.closest('.module-wrap[data-label], .gf_row[data-label]');
        let $newPlace = $parent.next('.block-placeholder');
        if ($newPlace.length == 0) {
          $newPlace = jQuery('<div class="block-placeholder" />');
          $parent.after($newPlace);
        }

        // History
        let $itemContent;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $element);
        }

        const history = {
          id: $element.attr('id'),
          action: 'move',
          events: [
            {
              action: 'cut',
              position: position,
            },
          ],
        };
        $gryffEditor.trigger('history', history);

        const $from = $element.closest('.item-content');
        const $to = $element.closest('.item-content');

        const $eHandle = $element.children('.gf-tool-wrap').find('.e-handle');
        $eHandle.data('gfdraggable').manageStop($newPlace, $element, $from, $to);

        if (!HELPER.isInsideTheList($element)) {
          if (scrollToMe) {
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $element.offset().top - 80,
              },
              800,
            );
          }
        }
      }
    };

    this.deleteDataSettingByKey = function (elementId) {
      removeElement(elementId);
      app.$store.commit('editor/DELETE_DATA_SETTING_BY_KEY', {
        keyType: 'element',
        attrId: elementId,
        data: {
          [base._style]: true,
          [base._template]: true,
          [base._snippet]: true,
          [base._libs]: true,
          [base._data]: true,
          [base._script]: true,
          [base._settings]: true,
          [base._interactions]: true,
          [base._actions]: true,
          [base._actionsStyle]: true,
          [base._templateChildHtml]: true,
          [base._templateChildBkHtml]: true,
        },
      });
      return false;
    };

    // gfElement.doRemoveMe
    this.doRemoveMe = function (isGotoTab0, historyFlag) {
      HELPER.handleBlankPage();

      if (!isGotoTab0) {
        isGotoTab0 = true;
      }

      // update place holder
      const $placeholder = $element.next('.block-placeholder');
      if ($placeholder.length > 0) {
        $placeholder.remove();
      }

      const $rowEqualHeight = $element.closest('.gf_equal-height');
      const $itemContent = $element.closest('.item-content');
      const elementId = _this.getElementId();
      // check logic
      if (historyFlag == undefined) {
        historyFlag = true;
      }
      if (historyFlag) {
        const $currentTargetElement = $element;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $currentTargetElement);
        }

        const data = _this.export('clone');
        const history = {
          id: $currentTargetElement.attr('id'),
          action: 'delete',
          position: position,
          data: {
            html: data.html,
            bkHtml: data.bkHtml,
          },
        };

        _this.deleteDataSettingByKey(elementId);
        const $style = $elementStyleContainer.find('#' + base._style + '-' + elementId);
        $style.remove();

        $gryffEditor.trigger('history', history);
      }

      let flag = false;
      if (!HELPER.isInsideTheList($element)) {
        $element.remove();
        $divContentBk.find('#element-' + elementId).remove();
      } else {
        HELPER.flagListItemChange($element, 'delete');
        flag = true;
      }

      // detect element or module change
      HELPER.detectContentChange($itemContent);
      if ($rowEqualHeight.length > 0) {
        HELPER.refreshEqualHeight();
      }
      HELPER.refreshFrame();

      if (!flag) {
        while ($gryffBody.find('#e-' + elementId).length > 0) {
          $gryffBody
            .find('#e-' + elementId)
            .data('gfelement')
            .doRemoveMe();
        }
      }

      // go back to tab 0
      if (isGotoTab0) {
        $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
      }

      return false;
    };

    // gfElement.clone
    this.cloneMe = function (removeOrigin, scrollToMe) {
      if (removeOrigin == undefined) {
        var removeOrigin = false;
      }
      if (scrollToMe == undefined) {
        var scrollToMe = true;
      }
      const data = _this.export('clone');

      var html = data.html;
      var bkHtml = data.bkHtml;

      if (HELPER.isInsideTheList($element)) {
        var html = data.html;
        var bkHtml = data.bkHtml;

        const $tmpHtml = jQuery('<div />').html(html);
        const newIdList = [];

        $tmpHtml.find('[data-label][data-id]').each(function () {
          const oldId = jQuery(this).attr('data-id');
          const matchedString = new RegExp(oldId, 'g');

          var newId = HELPER.MakeIdInsideList($element, 'new');

          let increase = 0;
          while (jQuery.inArray(newId, newIdList) !== -1) {
            var newId = HELPER.MakeIdInsideList($element, 'new', increase);
            increase++;
          }
          newIdList.push(newId);

          html = html.replace(matchedString, newId);
          bkHtml = bkHtml.replace(matchedString, newId);
        });
      } else {
        const rData = HELPER.replaceIds(data.html, data.bkHtml);
        var html = rData.html;
        var bkHtml = rData.bkHtml;
      }

      $element.after(html);
      HELPER.addContentBk(bkHtml);

      const $newElement = $element.next('.element-wrap');
      // $newElement.gfElement();
      atom.Init($newElement, {
        isClone: true,
      });

      if ($newElement.attr('data-form')) {
        const $formField = $newElement.find('.elm').find('input, textarea, select');
        const oldName = $formField.attr('name');
        let newName = 'field-' + HELPER.MakeId();
        if (oldName) {
          if (oldName.indexOf('contact[') != -1) {
            newName = 'contact[' + newName + ']';
          }
        }
        $formField.attr('name', newName);
      }
      if (removeOrigin) {
        $element.data('gfelement').doRemoveMe();
      }

      HELPER.flagListItemChange($newElement, 'new');
      // detect element or module change
      const $itemContent = $element.closest('.item-content');
      HELPER.detectContentChange($itemContent);

      HELPER.refreshFrame();

      if (!HELPER.isInsideTheList($newElement)) {
        if (!removeOrigin && scrollToMe) {
          if (
            $newElement.offset().top + $gfFrame.offset().top - $gfFrame.contents().scrollTop() >
            window.innerHeight - 250
          ) {
            $gryffEditor.parents('html, body').animate(
              {
                scrollTop: $newElement.offset().top - 80,
              },
              800,
            );
          }
        }
      }

      setTimeout(function () {
        const $currentTargetElement = $newElement;
        let position = {};
        if ($gryffEditor.data('gfhistory')) {
          position = $gryffEditor.data('gfhistory').getPosition($itemContent, $currentTargetElement);
        }
        const history = {
          id: $currentTargetElement.attr('id'),
          action: 'add',
          position: position,
        };

        $gryffEditor.trigger('history', history);
      }, 300);

      return $newElement;
    };

    this.getElementHtmlForExport = function () {
      const $cloneElement = $element.clone();
      const $elementWrap = jQuery('<div />').html($cloneElement);

      $elementWrap.find('.gf_textfield').each(function () {
        const formName = jQuery(this).attr('name');
        jQuery(this).attr('name', formName);
      });
      $elementWrap.find('.gf_textarea').each(function () {
        const formName = jQuery(this).attr('name');
        jQuery(this).attr('name', formName);
      });
      $elementWrap.find('.gf_dropdown').each(function () {
        const formName = jQuery(this).attr('name');
        jQuery(this).attr('name', formName);
      });

      let html = $elementWrap.html();
      html = HELPER.clearExportedData(html);

      return html;
    };

    // gfElement.exportMe
    this.exportMe = function (exportType) {
      let html = _this.getElementHtmlForExport();
      let bkHtml = '';
      let style = '';
      let script = '';
      const libs = [];
      const fonts = [];

      const $html = jQuery('<div />').html(html);
      const $elm = $html.children('.element-wrap');
      const elementId = $elm.attr('data-id');

      if (elementId) {
        var $bkCloneElement = '';
        $bkCloneElement = HELPER.mergeDataSetting('element', elementId);

        const $bkElementHtml = jQuery('<div />').html($bkCloneElement);
        bkHtml += $bkElementHtml.html();

        style += HELPER.getStyleDataSetting('element', elementId);
        script += HELPER.getScriptDataSetting('element', elementId);

        const interactionData = app.$store.getters['editor/GET_ANIMATION_INTERACTION_SETTING_BY_KEY'](
          base._interactions + '_' + 'element-' + elementId,
        );
        if (interactionData) {
          script += this.parseInteraction2Scripts($elm, _this.getElementId(), interactionData, exportType);
        }
      }

      // --------------------------------------------------------------------
      html = $html.html();
      html = HELPER.clearExportedData(html);
      html = HELPER.compressHTML(html);
      html = HELPER.simpleHTMLEntities(html);
      style = HELPER.compressHTML(style);

      if (checkKeyValid('trackingError')) {
        if (!html || !bkHtml) {
          const elementId = _this.getElementId();
          window.trackingError.push(elementId);
        }
      }

      return {
        html: html,
        bkHtml: bkHtml,
        style: style,
        script: script,
        libs: libs,
        fonts: fonts,
      };
    };

    this.export = function (exportType) {
      return _this.exportMe(exportType);
    };

    this.parseInteraction2Scripts = function ($element, elementId, interaction, exportType) {
      let script = '';
      let interactionJSON = {};
      try {
        interactionJSON = JSON.parse(interaction);
      } catch {
        interactionJSON = {};
      }
      if (interactionJSON && interactionJSON.animations) {
        interactionJSON.animations.forEach((e) => {
          try {
            const animationName = e.animation.name;
            const interaction = e.interaction;

            if (exportType != 'clone') {
              if (animationName.includes('_in') && SCROLL_VIEW_KEY.includes(interaction.key)) {
                $element.css('opacity', 0);
              }
              if (animationName.includes('_out')) {
                // Do nothing
              }
            }
            if (interaction) {
              switch (interaction.key) {
                case 'mouse-click':
                  script += `window.__gfAnimate.registerClick(jQuery("#e-${elementId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'mouse-hover':
                  script += `window.__gfAnimate.registerHover(jQuery("#e-${elementId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'mouse-leave':
                  script += `window.__gfAnimate.registerMouseLeave(jQuery("#e-${elementId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'after-page-loaded':
                  script += `window.__gfAnimate.registerPageLoaded(jQuery("#e-${elementId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'scroll-into-view':
                  script += `window.__gfAnimate.registerScroll(jQuery("#e-${elementId}"), '${JSON.stringify(e)}');`;
                  break;
                case 'scrolling-in-view':
                  script += `window.__gfAnimate.registerScrolling(jQuery("#e-${elementId}"), '${JSON.stringify(e)}');`;
                  break;
              }
            }
          } catch {}
        });
      }
      return script;
    };

    this.copyCSS = function () {
      const style = _this.getElementCSS();
      const id = this.getElementId();
      const label = this.getElementName();
      const dataClipBoardCSS = {
        id: id,
        label: label,
        style: style,
      };
      store.setValue('__clipBoardCSS', dataClipBoardCSS);
    };
    this.pasteCSS = function () {
      const clipBoardCSS = store.getValue('__clipBoardCSS') || {};
      const id = this.getElementId();
      const label = this.getElementName();
      if (!jQuery.isEmptyObject(clipBoardCSS) && label == clipBoardCSS.label) {
        const oldStyle = this.getElementCSS();
        let style = clipBoardCSS.style;
        if (id != clipBoardCSS.id) {
          const oldId = new RegExp(clipBoardCSS.id, 'g');
          style = style.replace(oldId, id);
        }
        this.setElementCSS(style);

        HELPER.flagListItemChange($element, 'replace');
        HELPER.detectContentChange($element);

        //add history
        const extra = {
          edit: 'css',
          style: oldStyle,
        };
        if ($gryffEditor.data('gfhistory') && $element && $element.attr('id') != undefined) {
          $gryffEditor.data('gfhistory').addHistory('editor', $element.attr('id'), extra);
        }

        this.openElementSettings();
      }
    };

    this.elementCSS = function () {
      $divContentHidden.find('#md-editor').remove();
      $divContentHidden.append(_mdEditor);
      $divContentHidden.find('[gf-tag="title"]').html(`Code Editor - ${$element.attr('data-label')}`);

      const style = _this.getElementCSS();
      const oldStyle = style;

      const $activeModal = jQuery('#md-editor');
      $activeModal.find('#styleCode').val(HELPER.formatCSS(style));

      const $cEditor = ace.edit('styleCode');
      $cEditor.setTheme('ace/theme/monokai');
      $cEditor.setAutoScrollEditorIntoView(true);
      $cEditor.getSession().setTabSize(2);
      $cEditor.getSession().setUseWrapMode(true);

      $cEditor.setHighlightActiveLine(false);
      $cEditor.setOption('maxLines', 27);
      $cEditor.setOption('minLines', 27);
      $cEditor.session.setMode('ace/mode/css');

      $activeModal.gfModal({
        opacity: 0.4,
        bg: 'rgb(62, 62, 62)',
        zIndex: 9999999,
      });

      var mw = jQuery(window).outerWidth() < 1000 ? jQuery(window).outerWidth() : 1000;
      $activeModal
        .data('gfmodal')
        .setTitle('CSS')
        .setWidth(mw + 'px')
        // .setHeight('500px')
        .centerModal() //
        .show();

      $activeModal
        .find('.btnSave')
        .off()
        .on('click', function (e) {
          const style = $cEditor.getValue();
          _this.setElementCSS(style);

          HELPER.flagListItemChange($element, 'replace');
          HELPER.detectContentChange($element);

          $activeModal.data('gfmodal').hide();

          // History
          const extra = {
            edit: 'css',
            style: oldStyle,
          };
          if ($gryffEditor.data('gfhistory') && $element && $element.attr('id') != undefined) {
            $gryffEditor.data('gfhistory').addHistory('editor', $element.attr('id'), extra);
          }

          if (checkKeyValid('editCodeSaveUpdateSidebarSetting')) {
            _this.openElementSettings(undefined, undefined, undefined, true);
          }
          return false;
        });
      return false;
    };

    this.editCode = function (enableSections = []) {
      let template;
      $divContentHidden.find('#md-editor').remove();
      $divContentHidden.append(_mdEditor);
      $divContentHidden.find('[gf-tag="title"]').html(`Code Editor - ${$element.attr('data-label')}`);
      const label = _this.getElementName();

      if (['Heading', 'Text Block', 'Image', 'Button', 'Icon', 'Dropdown'].includes(label)) {
        template = $element.find('.elm').html();
        if (checkKeyValid('editCodeSaveUpdateSidebarSetting')) {
          switch (label) {
            case 'Dropdown':
              template = HELPER.formatHtml(template);
              break;
          }
        }
      } else {
        template = _this.getElementTemplate();
      }

      const oldTemplate = template;
      const style = _this.getElementCSS();
      const oldStyle = style;

      const $activeModal = $divContentHidden.find('#md-editor');

      $activeModal.find('#templateCode').hide().val(template);
      $activeModal.find('#styleCode').hide().val(style);

      const $codeEditor = {
        template: null,
        style: null,
      };

      var templateTrackingTime = 0
      var styleTrackingTime = 0
      var scriptTrackingTime = 0
      
      // Đánh active cho tab đầu tiên không bị disable
      {
        const tab = enableSections[0];
        var startTrackingTime = Date.now();
        $activeModal.find(`[gf-tabs]>[gf-tab="${tab}"]`).addClass('active is-selected');
        $codeEditor[tab] = initAce(tab + 'Code', tab);
      }

      // huỷ trạng thái disable của những tab được active
      $activeModal.find('[gf-tabs]>[gf-tab]').each(function () {
        const $item = jQuery(this);
        const tab = ($item.attr('gf-tab') || '').toLowerCase();
        if (enableSections.includes(tab)) {
          $item.removeClass('disabled');
        }
      });

      $activeModal.gfModal({
        opacity: 0.4,
        bg: 'rgb(62, 62, 62)',
        zIndex: 9999999,
      });

      const mw = jQuery(window).outerWidth() < 1000 ? jQuery(window).outerWidth() : 1000;
      $activeModal
        .data('gfmodal')
        .setTitle('#e-' + $element.attr('data-id') + utils.svgIcon('copy'))
        .setWidth(mw + 'px')
        .centerModal() //
        .show();

      let __timeout = null;
      // xử lý click vào tag để copy id
      $activeModal
        .find('[gf-action="click:copyToClipboard"]')
        .off('click.clipboard')
        .on('click.clipboard', function () {
          const copied = copyToClipboard('#e-' + $element.attr('data-id'));
          if (copied) {
            const $thisSpan = jQuery(this);
            $thisSpan.parent().find('[gf-span="msg"]').remove();
            clearTimeout(__timeout);
            const $msg = jQuery(`<span gf-span="msg">Copied!</span>`);
            $msg.css({
              color: '#42C184',
              'font-size': '12px',
              'margin-left': '4px',
            });

            $thisSpan.after($msg);
            __timeout = setTimeout(() => {
              $thisSpan.next('span').remove();
            }, 1500);
          }
        });       
      // xử lý chuyển tab
      $activeModal
        .find('[gf-tabs]>[gf-tab]')
        .off('click.changeTab')
        .on('click.changeTab', function () {
          const $selectedTab = jQuery(this);
          const tab = $selectedTab.attr('gf-tab');
          if (!enableSections.includes(tab)) {
            return;
          }

          const tabAtrr = $activeModal.find('.active').attr('gf-tab');
          const activeTime = Date.now() - startTrackingTime
          if(tabAtrr === 'template'){
            templateTrackingTime += activeTime;
          }
          if(tabAtrr === 'style'){
            styleTrackingTime += activeTime
          }
          if(tabAtrr === 'script'){
            scriptTrackingTime += activeTime
          }
          startTrackingTime = Date.now()
          
          $activeModal.find('[gf-tabs]>[gf-tab]').removeClass('active');
          $selectedTab.addClass('active is-selected');

          Object.keys($codeEditor).forEach((key) => {
            if ($codeEditor[key]) {
              jQuery($codeEditor[key].container).hide();
            }
          });

          if ($codeEditor[tab]) {
            jQuery($codeEditor[tab].container).show();
          } else {
            $codeEditor[tab] = initAce(tab + 'Code', tab);
          }
        });

      // xử lý lưu
      $activeModal
        .find('.btnSave')
        .off()
        .on('click', function (e) {
          const tabAtrr = $activeModal.find('.active').attr('gf-tab');
          const activeTime = Date.now() - startTrackingTime
          if(tabAtrr === 'template'){
            templateTrackingTime += activeTime;
          }
          if(tabAtrr === 'style'){
            styleTrackingTime += activeTime
          }
          if(tabAtrr === 'script'){
            scriptTrackingTime += activeTime
          }
          const labelElement = $element.attr('data-label') || 'Row';
          $activeModal.find('.is-selected').each(function () {
            const tabAtrrItem = jQuery(this).attr('gf-tab');
            let trackingTimeItem = 0
            if(tabAtrrItem === 'template'){
              trackingTimeItem = templateTrackingTime
              templateTrackingTime = 0
            }
            if(tabAtrrItem === 'style'){
              trackingTimeItem = styleTrackingTime
              styleTrackingTime = 0
            }
            if(tabAtrrItem === 'script'){
              trackingTimeItem = scriptTrackingTime
              scriptTrackingTime = 0
            }
            const tabNameItem = jQuery(this).text();
            const gfFrameData = $gfFrame.data('gfframe');
            app.$store.dispatch('common/trackEvent', { 
              eventId: EDITOR_EVENT.GS_CUSTOM_CODE_SAVED,
              properties: {
                shop_domain: gfFrameData.getShopDomain(),
                template_page_id: gfFrameData.getPageId(),
                product_element_type: labelElement,
                tab_custom: tabNameItem,
                tab_tracking_time: trackingTimeItem,
              },
          })
          });
          
          enableSections.forEach((key) => {
            if (!$codeEditor[key]) {
              return;
            }

            const val = $codeEditor[key].getValue();
            if (key === 'template') {
              _this.setElementTemplate(val);
            } else if (key === 'style') {
              _this.setElementCSS(val);
            }
          });

          HELPER.flagListItemChange($element, 'replace');
          HELPER.detectContentChange($element);

          $activeModal.data('gfmodal').hide();

          // History
          const extra = {
            edit: 'code',
            template: oldTemplate,
            style: oldStyle,
          };

          if ($gryffEditor.data('gfhistory') && $element && $element.attr('id') !== undefined) {
            $gryffEditor.data('gfhistory').addHistory('editor', $element.attr('id'), extra);
          }
          return false;
        });
    };

    this.detectElementChange = function () {};

    this.getTargetStyleClass = function () {
      const type = $element.attr('data-label') ? $element.attr('data-label').toLowerCase().split(' ').join('-') : '';
      let eClass = '';

      for (let i = 0; i < elementInfo.length; i++) {
        if (jQuery.trim(elementInfo[i].slug) == type) {
          eClass = '.' + jQuery.trim(elementInfo[i].class);

          break;
        }
      }

      const $self = $element.find(eClass);

      let targetClass = _this.getTargetClass();
      let $heading = $self.children('h1,h2,h3,h4,h5,h6');
      if ($heading.length > 0) {
        switch ($heading.prop('tagName').toLowerCase()) {
          case 'h1':
            targetClass += ' h1';
            break;

          case 'h2':
            targetClass += ' h2';
            break;

          case 'h3':
            targetClass += ' h3';
            break;

          case 'h4':
            targetClass += ' h4';
            break;

          case 'h5':
            targetClass += ' h5';
            break;

          case 'h6':
            targetClass += ' h6';
            break;
        }
      }
      return targetClass;
    };

    this.manualStyleSetting = function (deOptions) {
      // var deOptions = [
      //   {
      //     key: 'font-family',
      //     value: style1.fontFamily,
      //   },
      //   { key: 'font-weight', value: style1.fontWeight },
      // ];

      let style = _this.getElementCSS();
      let targetClass = _this.getTargetStyleClass();
      const screenType =
        $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';

      style = HELPER.designOptions2Style($element, screenType, style, deOptions, targetClass);
      _this.setElementCSS(style);
    };

    this.highlightCounter = function (elementId) {
      app.$store.commit('sidebar/SET_SIDE_BAR_SETTING_ELEMENT_ID', {
        merId: this.getElementTargetId(),
        type: 'element',
      });
      const $mdSettings = $gfLeftSideBar.find('#md-settings');
      let _counter = $mdSettings.attr('hightlight-counter');
      if (!_counter) {
        _counter = 'id,number';
      }
      const $arrayCounter = _counter.split(',');
      const _id = $arrayCounter[0];
      let _number = $arrayCounter[1];

      if (elementId != _id) {
        _number = 1;
      } else {
        _number = parseInt(_number) + 1;
      }
      $mdSettings.attr('hightlight-counter', elementId + ',' + _number);

      return _number;
    };

    //TRUONGNC-NEW
    this.openElementSettings = function (tab, drag, capture, saved = false) {
      const $toolHighlightWrapper = $element.children('.gf-error-wrapper');
      let errorId = null;
      if ($toolHighlightWrapper.length > 0) {
        const errorActive = $toolHighlightWrapper.find('.gf-error-highlight.gf-highlight-display');
        if (errorActive) {
          errorId = errorActive.attr('id');
          emitter.emit('gemmeter:click-event', {
            merId: $element.attr('id'),
            errorId,
          });
        }
      }
      const doOpenElementSettings = function () {
        if (tab) {
          const arrayTab = tab.split(':');
          tab = arrayTab[0];
          var columnOpen = arrayTab[1];
        }

        $gfLeftSideBar.data('gfleftsidebar').showHighlighter('element-panel');
        const elementId = _this.getElementId();
        const elementName = _this.getElementName();

        // Đếm số lượt mở open setting để cảnh báo đến người dùng.
        if (drag == undefined) {
          drag = false;
        }
        if (!drag) {
          const _countHighlight = _this.highlightCounter(elementId);
          if (_countHighlight >= 3 && _countHighlight < 5) {
            const $hightlight = jQuery('<div class="gf_panel-hightlight-all element-panel"></div>');
            $gfLeftSideBar.find('.side-panels').append($hightlight);
            setTimeout(function () {
              $hightlight.remove();
            }, 1000);
          }
        }

        // avoid 3 times open
        const $mdSettings = $gfLeftSideBar.find('#md-settings');
        const currentTab = $mdSettings.find('.simple-tabs ul.simple-tabs-item li.active').text().trim();
        const newTab = tab ? tab : 'Settings';
        const merId = $mdSettings.data('edittingID');
        if ($mdSettings.hasClass('active') && merId == $element.attr('id') && currentTab == newTab) {
          app.$store.commit('sidebar/CHANGE_ACTIVE_TAB', {
            key: 'elements',
          });
          return false;
        }

        const type = $element.attr('data-label') ? $element.attr('data-label').toLowerCase().split(' ').join('-') : '';
        const $bkActiveElement = $divContentBk.find('#element-' + elementId);
        const $template = $bkActiveElement.find('.template');
        const $style = $bkActiveElement.find('.style');

        let $gfTabs;
        var $activePanel;

        let eClass = '';
        let eId = '';
        let mdHtml = '';
        let mdSettings = '';

        for (let i = 0; i < elementInfo.length; i++) {
          if (jQuery.trim(elementInfo[i].slug) == type) {
            eClass = '.' + jQuery.trim(elementInfo[i].class);
            eId = jQuery.trim(elementInfo[i].id);
            mdHtml = elementInfo[i].html;
            mdSettings = elementInfo[i].settings;
            break;
          }
        }

        switch (type) {
          case 'heading':
          case 'text-block':
            var $self = $element.find(eClass);
            var $elm = $element.find('.elm');

            var $activePanel = $gfLeftSideBar
              .data('gfleftsidebar')
              .showMDSettingsPanel('element', mdHtml, $element.attr('id'), eId);
            var fields = mdSettings;

            var $settingsPanel = $gfLeftSideBar.find('#md-text-block .md-body.settings-panel');
            $settingsPanel.gfFormRender({
              fields: fields,
              onRender: function () {},
            });

            renderTabSettings.initGlobalStyle(type);

            // reload Tabs
            $gfTabs = $activePanel.find('.simple-tabs');

            $gfTabs.gfTabs({
              targetElement: $self,
              onSettingsChanged: function ($input) {
                saveSettings($input);
              },
              onTabClick: function (tabName) {
                switch (tabName) {
                  case 'Settings':
                    var getSettingOptions = function () {
                      let targetClass = _this.getTargetClass();
                      let $heading = $self.children('h1,h2,h3,h4,h5,h6');
                      if ($heading.length > 0) {
                        var headingTag = $heading.prop('tagName').toLowerCase();
                        $activePanel
                          .find('select[name="titleTag"]')
                          .attr('value', headingTag)
                          .val(headingTag)
                          .trigger('value-change');

                        switch ($heading.prop('tagName').toLowerCase()) {
                          case 'h1':
                            targetClass += ' h1';
                            break;

                          case 'h2':
                            targetClass += ' h2';
                            break;

                          case 'h3':
                            targetClass += ' h3';
                            break;

                          case 'h4':
                            targetClass += ' h4';
                            break;

                          case 'h5':
                            targetClass += ' h5';
                            break;

                          case 'h6':
                            targetClass += ' h6';
                            break;
                        }
                      } else {
                        $heading = $self;
                      }

                      const style = _this.getElementCSS();

                      const screenType =
                        $gfResTool.data('gfrestool') != undefined
                          ? $gfResTool.data('gfrestool').getCurrentStatus()
                          : 'lg';

                      let fontSize = HELPER.getValueFromCSS($element, style, 'font-size', screenType, targetClass);
                      if (fontSize == '') {
                        fontSize = parseFloat($heading.css('font-size'));
                      }
                      $activePanel
                        .find('input[name="font-size"]')
                        .val(fontSize)
                        .attr('value', fontSize)
                        .trigger('value-change');

                      let lineHeight = HELPER.getValueFromCSS($element, style, 'line-height', screenType, targetClass);
                      if ($activePanel.find('#line-height').attr('unit') == 'em') {
                        if (lineHeight == '') {
                          lineHeight = parseFloat($heading.css('line-height'));
                          lineHeight = lineHeight / parseFloat(fontSize);
                          lineHeight += 'em';
                        }
                        if (lineHeight.indexOf('px') !== -1) {
                          lineHeight = parseFloat(lineHeight);
                          lineHeight = lineHeight / parseFloat(fontSize);
                          lineHeight += 'em';
                        }
                      } else if ($activePanel.find('#line-height').attr('unit') == 'px') {
                        if (lineHeight == '') {
                          lineHeight = $heading.css('line-height');
                        }
                        if (lineHeight.indexOf('em') !== -1) {
                          lineHeight = parseFloat(lineHeight);
                          lineHeight = fontSize * lineHeight;
                          lineHeight += 'px';
                        }
                      }
                      $activePanel
                        .find('input[name="line-height"]')
                        .val(lineHeight)
                        .attr('value', lineHeight)
                        .trigger('value-change');

                      let letterSpacing = HELPER.getValueFromCSS(
                        $element,
                        style,
                        'letter-spacing',
                        screenType,
                        targetClass,
                      );
                      if (letterSpacing == '') {
                        letterSpacing = parseFloat($heading.css('letter-spacing'));
                      }
                      $activePanel
                        .find('input[name="letter-spacing"]')
                        .val(letterSpacing)
                        .attr('value', letterSpacing)
                        .trigger('value-change');

                      let fontFamily = HELPER.getValueFromCSS($element, style, 'font-family', screenType, targetClass);
                      // if(fontFamily == '') {
                      //     fontFamily = $heading.css('font-family');
                      // }

                      fontFamily = jQuery.trim(fontFamily);
                      if (fontFamily === '') fontFamily = 'inherit';
                      $gfLeftSideBar
                        .find('.gfFontSelect')
                        .find('select')
                        .attr('value', fontFamily)
                        .trigger('value-change');
                      // TRUONGNC
                      const $fontInputElement = $activePanel.find('input[name="font"]');
                      $fontInputElement.val(fontFamily).attr('value', fontFamily).trigger('value-change');

                      const data = { settings: null, $element: $fontInputElement };
                      renderFontList(false, data);

                      let color = HELPER.getValueFromCSS($element, style, 'color', screenType, targetClass);
                      if (!color) {
                        color = HELPER.rgb2hex($heading.css('color'));
                      }
                      $activePanel
                        .find('input[name="text-color"]')
                        .val(color)
                        .attr('value', color)
                        .trigger('value-change');

                      let textTransform = HELPER.getValueFromCSS(
                        $element,
                        style,
                        'text-transform',
                        screenType,
                        targetClass,
                      );
                      if (textTransform == '') {
                        textTransform = $heading.css('text-transform');
                      }
                      $activePanel
                        .find('select[name="textTransform"]')
                        .val(textTransform)
                        .attr('value', textTransform)
                        .trigger('value-change');

                      let textShadow = HELPER.getValueFromCSS($element, style, 'text-shadow', screenType, targetClass);
                      if (textShadow == '') {
                        textShadow = $heading.css('text-shadow');
                      }

                      if (textShadow && textShadow != 'none') {
                        $activePanel
                          .find('input[name="box-shadow-enable"]')
                          .val('1')
                          .attr('value', '1')
                          .trigger('value-change');
                        textShadow = textShadow.split('px ');
                        $activePanel
                          .find('input[name="box-shadow-color"]')
                          .val(textShadow[3])
                          .attr('value', textShadow[3])
                          .trigger('value-change');
                        $activePanel
                          .find('input[name="box-shadow-blur"]')
                          .val(textShadow[2])
                          .attr('value', textShadow[2])
                          .trigger('value-change');
                        setTimeout(function () {
                          $activePanel
                            .find('input[name="gf-to-shadowXY"]')
                            .val(textShadow[0] + ',' + textShadow[1])
                            .attr('value', textShadow[0] + ',' + textShadow[1])
                            .trigger('value-change');
                        }, 100);
                      } else {
                        $activePanel
                          .find('input[name="box-shadow-enable"]')
                          .val('0')
                          .attr('value', '0')
                          .trigger('value-change');
                      }

                      let align = HELPER.getResponsiveAlign($elm, screenType);

                      /* Heading + Text Block align for old version */
                      const $child = $elm.children('p,h1,h2,h3,h4,h5,h6');

                      // Get class global style
                      let tag = '';
                      if (type == 'heading') {
                        tag = headingTag;
                      }
                      renderTabSettings.applySettingSnipetGlobalStyle(type, _this.getElementTargetId(), tag);

                      if ($child.length > 0 && $child.attr('style') != undefined) {
                        let styleString = $child.attr('style');
                        const regex = 'text-align(.*?)?;';

                        if (styleString.match(regex)) {
                          const matched = styleString.match(regex)[0];

                          let flag = false;
                          if (matched.indexOf('left') !== -1) {
                            align = 'left';
                            flag = true;
                          } else if (matched.indexOf('center') !== -1) {
                            align = 'center';
                            flag = true;
                          } else if (matched.indexOf('right') !== -1) {
                            align = 'right';
                            flag = true;
                          } else if (matched.indexOf('justify') !== -1) {
                            align = 'justify';
                            flag = true;
                          }
                          if (flag) {
                            $elm
                              .removeClass('gf-elm-left gf-elm-center gf-elm-right gf-elm-justify')
                              .addClass('gf-elm-' + align);
                            const matchedString = new RegExp(matched, 'g');
                            styleString = styleString.replace(matchedString, 'text-align: inherit!important;');
                            $child.attr('style', styleString);
                          }
                        }
                      }

                      $activePanel.find('.gf_to-align').attr('value', align).val(align).trigger('value-change');

                      let extraClass = $elm.attr('data-exc');
                      if (!extraClass) {
                        extraClass = '';
                      }
                      $activePanel.find('input[name="extra_class"]').attr('value', extraClass).val(extraClass);
                      setFontWeight({ $activePanel, $self, style, screenType, selector: targetClass });
                    };

                    // call
                    getSettingOptions();

                    setTimeout(function () {
                      $activePanel.find('select[name="titleTag"]').on('input-change', function () {
                        getSettingOptions();
                      });
                    }, 10);

                    break;

                  case 'Design':
                    if ($gfTabs.data('gftabs') != undefined) {
                      $gfTabs.data('gftabs').onDesignOptionsTabClick();
                    }
                    break;
                }
                setTimeout(function () {
                  // capture history setting
                  if (capture != false) {
                    $gryffEditor.data('gfhistory').captureMERSettings();
                  }
                }, 100);
              },
            });

            var saveSettings = function ($input) {
              validateInput($input);
              let targetClass = _this.getTargetClass();

              const $heading = $self.children('h1,h2,h3,h4,h5,h6');
              if ($heading.length > 0) {
                var headingTag = $activePanel.find('select[name="titleTag"]').val();

                $($heading).replaceWith(function () {
                  return `<${headingTag} class="${$heading.attr('class')}">${$(this).html()}</${headingTag}>`;
                });

                switch ($heading.prop('tagName').toLowerCase()) {
                  case 'h1':
                    targetClass += ' h1';
                    break;

                  case 'h2':
                    targetClass += ' h2';
                    break;

                  case 'h3':
                    targetClass += ' h3';
                    break;

                  case 'h4':
                    targetClass += ' h4';
                    break;

                  case 'h5':
                    targetClass += ' h5';
                    break;

                  case 'h6':
                    targetClass += ' h6';
                    break;
                }
              }

              let shadowXY = $activePanel.find('input[name="gf-to-shadowXY"]').val();
              let textShadowValue = '';
              if (shadowXY) {
                shadowXY = shadowXY.split(',');
              } else {
                shadowXY = ['0', '0'];
              }
              textShadowValue =
                $activePanel.find('input[name="box-shadow-enable"]').val() == '1'
                  ? (shadowXY.length >= 2 ? shadowXY[0] : 0) +
                    'px ' +
                    (shadowXY.length >= 2 ? shadowXY[1] : 0) +
                    'px ' +
                    $activePanel.find('input[name="box-shadow-blur"]').val() +
                    ' ' +
                    $activePanel.find('input[name="box-shadow-color"]').val()
                  : '';

              const inputName = $input.attr('name');
              if (
                inputName &&
                (inputName == 'box-shadow-enable' ||
                  inputName == 'box-shadow-color' ||
                  inputName == 'gf-to-shadowXY' ||
                  inputName == 'box-shadow-angle' ||
                  inputName == 'box-shadow-distance' ||
                  inputName == 'box-shadow-blur')
              ) {
                var deOptions = [
                  {
                    key: 'text-shadow',
                    value: textShadowValue,
                  },
                ];
              } else {
                var deOptions = [
                  {
                    key: 'font-size',
                    value: $activePanel.find('input[name="font-size"]').val(),
                  },
                  {
                    key: 'line-height',
                    value: $activePanel.find('input[name="line-height"]').val(),
                  },
                  {
                    key: 'letter-spacing',
                    value: $activePanel.find('input[name="letter-spacing"]').val(),
                  },
                  {
                    key: 'font-family',
                    value: $activePanel.find('input[name="font"]').val(),
                  },
                  {
                    key: 'color',
                    value: $activePanel.find('input[name="text-color"]').val(),
                  },
                  {
                    key: 'text-transform',
                    value: $activePanel.find('select[name="textTransform"]').attr('value'),
                  },
                  getFontWeightDesignOption({ $activePanel }),
                ];
              }

              let style = _this.getElementCSS();
              const screenType =
                $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';

              style = HELPER.designOptions2Style($element, screenType, style, deOptions, targetClass);
              _this.setElementCSS(style);

              if (deOptions.length > 1) {
                const align = $activePanel.find('select[name="alignment"]').attr('value');
                HELPER.setResponsiveAlign(align, $elm, screenType);
              }

              let oExClass = $elm.attr('data-exc');
              if (!oExClass) {
                oExClass = '';
              }
              const nExClass = $activePanel
                .find('input[name="extra_class"]')
                .attr('value')
                .replace(/[^a-z0-9_\-\ ]/gi, '');
              $elm.removeClass(oExClass).addClass(nExClass).attr('data-exc', nExClass);

              //----------------------
              HELPER.flagListItemChange($element, 'settings');

              const $itemContent = $element.closest('.item-content');
              HELPER.detectContentChange($itemContent);

              // Add class global style
              let tag = '';
              if (type == 'heading') {
                tag = headingTag;
              }

              return false;
            };

            renderTabSettings.visibleSettingGlobalStyle(type);
            break;

          case 'button':
            var $self = $element.find(eClass);
            var $elm = $element.find('.elm');

            var $activePanel = $gfLeftSideBar
              .data('gfleftsidebar')
              .showMDSettingsPanel('element', mdHtml, $element.attr('id'), eId);

            var fields = mdSettings;

            var $settingsPanel = $gfLeftSideBar.find('#md-link .md-body.settings-panel');
            $settingsPanel.gfFormRender({
              fields: fields,
              onRender: function () {},
            });

            renderTabSettings.initGlobalStyle(type);

            // reload Tabs
            $gfTabs = $activePanel.find('.simple-tabs');
            $gfTabs.gfTabs({
              targetElement: $self,
              onSettingsChanged: function ($input) {
                saveSettings($input);
              },
              onTabClick: function (tabName) {
                switch (tabName) {
                  case 'Settings':
                    var screenType =
                      $gfResTool.data('gfrestool') != undefined
                        ? $gfResTool.data('gfrestool').getCurrentStatus()
                        : 'lg';
                    var $settingsPanel = $activePanel.find('.settings-panel');
                    const href = $self.attr('href');
                    const urlHref = href.replace(SHOP_LOCALE_URL, '');

                    $settingsPanel.find('.editLink').attr('value', urlHref).val(urlHref);
                    $settingsPanel.find('.linkTarget').attr('value', $self.attr('target')).val($self.attr('target'));

                    //custom scrollspeed
                    const attrScrollSpeed = HELPER.getDataNameScreen('data-scroll-speed', screenType);
                    let scrollSpeed = $self.attr(attrScrollSpeed);

                    if (!scrollSpeed) {
                      for (let i = 0; i < fields.length; i++) {
                        if (fields[i].name == 'scrollSpeed') {
                          scrollSpeed = fields[i].default_value;
                        }
                      }
                    }

                    if (scrollSpeed) {
                      $settingsPanel
                        .find('#scrollSpeed')
                        .attr('value', scrollSpeed)
                        .val(scrollSpeed)
                        .trigger('value-change');
                    }

                    // Loại bỏ thẻ span ở button;
                    var editText = '';
                    if ($self.children('span').length > 0) {
                      editText = $self.children('span').html();
                    } else {
                      var editText = $self.html();
                    }
                    $settingsPanel.find('.editText').attr('value', editText).val(editText);

                    var align = HELPER.getResponsiveAlign($elm, screenType);
                    $activePanel.find('.gf_to-align').attr('value', align).val(align).trigger('value-change');

                    var style = _this.getElementCSS();

                    var width = HELPER.getValueFromCSS($self, style, 'width', screenType);
                    var height = HELPER.getValueFromCSS($self, style, 'height', screenType);

                    var btnColor = HELPER.getValueFromCSS($self, style, 'background-color', screenType);
                    /* Not getting from browser css to avoid css overwriting problem from default theme */

                    var color = HELPER.getValueFromCSS($self, style, 'color', screenType);
                    /* Not getting from browser css to avoid css overwriting problem from default theme */

                    var btnColorHover = HELPER.getValueFromCSS(
                      $self,
                      style,
                      'background-color',
                      screenType,
                      eClass + ':hover',
                    );
                    /* Not getting from browser css to avoid css overwriting problem from default theme */

                    var colorHover = HELPER.getValueFromCSS($self, style, 'color', screenType, eClass + ':hover');
                    /* Not getting from browser css to avoid css overwriting problem from default theme */

                    var fontFamily = HELPER.getValueFromCSS($self, style, 'font-family', screenType);
                    /* Not getting from browser css to avoid css overwriting problem from default theme */
                    var fontSize = HELPER.getValueFromCSS($self, style, 'font-size', screenType);
                    if (fontSize == '') {
                      fontSize = $self.css('font-size');
                    }

                    var textTransform = HELPER.getValueFromCSS($self, style, 'text-transform', screenType);
                    if (textTransform == '') {
                      textTransform = $self.css('text-transform');
                    }

                    // set width height + fontsize
                    $activePanel.find('#button-color').attr('value', btnColor).val(btnColor).trigger('value-change');
                    $activePanel.find('#text-color').attr('value', color).val(color).trigger('value-change');
                    if (btnColorHover != '' || colorHover != '') {
                      $activePanel.find('#buttonHover').attr('value', 1).val(1).trigger('value-change');
                    } else {
                      $activePanel.find('#buttonHover').attr('value', 0).val(0).trigger('value-change');
                    }
                    $activePanel
                      .find('#button-color-hover')
                      .attr('value', btnColorHover)
                      .val(btnColorHover)
                      .trigger('value-change');
                    $activePanel
                      .find('#text-color-hover')
                      .attr('value', colorHover)
                      .val(colorHover)
                      .trigger('value-change');

                    //custom stretch
                    const attrStretch = 'data-stretch-' + screenType;
                    let stretch = $elm.attr(attrStretch);

                    if (!stretch) {
                      for (let i = 0; i < fields.length; i++) {
                        if (fields[i].name == 'stretch') {
                          stretch = fields[i].default_value;
                        }
                      }
                    }

                    if (stretch) {
                      $activePanel.find('#stretch').attr('value', stretch).val(stretch).trigger('value-change');
                    } else {
                      $activePanel.find('#stretch').attr('value', 0).val(0).trigger('value-change');
                    }

                    $activePanel.find('.width').attr('value', width).val(width).trigger('value-change');
                    $activePanel.find('.height').attr('value', height).val(height).trigger('value-change');
                    $activePanel.find('.gf_font').attr('value', fontFamily).val(fontFamily).trigger('value-change');
                    $activePanel
                      .find('#font-size')
                      .attr('value', fontSize)
                      .val(fontSize)
                      .attr('value', fontSize)
                      .trigger('value-change');
                    $activePanel
                      .find('.textTransform')
                      .val(textTransform)
                      .attr('value', textTransform)
                      .trigger('value-change');

                    var extraClass = $self.attr('data-exc');
                    if (!extraClass) {
                      extraClass = '';
                    }
                    $activePanel
                      .find('input[name="extra_class"]')
                      .attr('value', extraClass)
                      .val(extraClass)
                      .trigger('value-change');
                    setFontWeight({ $activePanel, $self, style, screenType });
                    // Get class global style
                    renderTabSettings.applySettingSnipetGlobalStyle(type, _this.getElementTargetId());
                    break;

                  case 'Design':
                    if ($gfTabs.data('gftabs') != undefined) {
                      $gfTabs.data('gftabs').onDesignOptionsTabClick();
                    }
                    break;
                }
                setTimeout(function () {
                  // capture history setting
                  if (capture != false) {
                    $gryffEditor.data('gfhistory').captureMERSettings();
                  }
                }, 100);
              },
            });

            var saveSettings = function ($input) {
              validateInput($input);
              const _addClass = [],
                _removeClass = [];

              const screenType =
                $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
              let style = _this.getElementCSS();

              // Apply setting style
              const $settingsPanel = $activePanel.find('.settings-panel');

              // Thêm thẻ span.
              const editText = $settingsPanel.find('.editText').attr('value');
              if ($self.children('span').length > 0) {
                $self.children('span').html(editText);
              } else {
                $self.html(editText);
              }
              let urlHref = $settingsPanel.find('.editLink').attr('value');

              const regexHttp = new RegExp(/^https?:\/\//i);
              const regexPageType = new RegExp(/^\/?(?:collections|pages|products|blogs)\/?/i);
              if (!regexHttp.test(urlHref) && regexPageType.test(urlHref)) {
                urlHref = SHOP_LOCALE_URL + urlHref;
              }

              $self.attr('href', urlHref).attr('target', $settingsPanel.find('.linkTarget').attr('value'));

              //scrollSpeed
              const attrScrollSpeed = HELPER.getDataNameScreen('data-scroll-speed', screenType);
              $self.attr(attrScrollSpeed, $settingsPanel.find('.scrollSpeed').attr('value'));

              // Button align
              const align = $activePanel.find('.gf_to-align').attr('value');
              HELPER.setResponsiveAlign(align, $elm, screenType);

              // width & height
              if (
                ($self.css('paddingTop') != '0px' || $self.css('paddingBottom') != '0px') &&
                $self[0].style.height != $activePanel.find('.height').attr('value')
              ) {
                $self.css({
                  paddingTop: '0px',
                  paddingBottom: '0px',
                });
              }

              //custom stretch
              const attrStretch = 'data-stretch-' + screenType;
              $elm.attr(attrStretch, $settingsPanel.find('#stretch').attr('value'));

              var deOptions = [
                {
                  key: 'width',
                  value: $activePanel.find('.width').attr('value'),
                },
                {
                  key: 'height',
                  value: $activePanel.find('.height').attr('value'),
                },
                {
                  key: 'font-size',
                  value: $activePanel.find('#font-size').attr('value'),
                },
                {
                  key: 'font-family',
                  value: $activePanel.find('.gf_font').attr('value'),
                },
                {
                  key: 'text-transform',
                  value: $activePanel.find('.textTransform').attr('value'),
                },
                {
                  key: 'background-color',
                  value: $activePanel.find('#button-color').attr('value'),
                },
                {
                  key: 'color',
                  value: $activePanel.find('#text-color').attr('value'),
                },
                getFontWeightDesignOption({ $activePanel }),
              ];
              if ($element.data('ver') == '1') {
                deOptions.push({
                  key: 'line-height',
                  value: $activePanel.find('.height').attr('value'),
                });
              }
              style = HELPER.designOptions2Style($element, screenType, style, deOptions);

              ////////// Set CSS style
              _this.setElementCSS(style);

              ///////// Set CSS style hover
              if ($activePanel.find('#buttonHover').val() == 1) {
                var bgColorHover = $activePanel.find('#button-color-hover').attr('value');
                var colorHover = $activePanel.find('#text-color-hover').attr('value');
              } else {
                var bgColorHover = '';
                var colorHover = '';
              }
              var deOptions = [
                {
                  key: 'background-color',
                  value: bgColorHover,
                },
                {
                  key: 'color',
                  value: colorHover,
                },
              ];
              style = HELPER.designOptions2Style($element, screenType, style, deOptions, eClass + ':hover');
              _this.setElementCSS(style);

              let oExClass = $self.attr('data-exc');
              if (!oExClass) {
                oExClass = '';
              }
              const nExClass = $activePanel
                .find('input[name="extra_class"]')
                .attr('value')
                .replace(/[^a-z0-9_\-\ ]/gi, '');
              _addClass.push(nExClass);
              _removeClass.push(oExClass);
              $self.attr('data-exc', nExClass);

              $self.removeClass(_removeClass.join(' ')).addClass(_addClass.join(' '));

              //----------------------

              HELPER.flagListItemChange($element, 'settings');

              const $itemContent = $element.closest('.item-content');
              HELPER.detectContentChange($itemContent);

              // Add class global style

              return false;
            };

            renderTabSettings.visibleSettingGlobalStyle(type);
            break;

          case 'submit-button':
            var $self = $element.find(eClass);
            var $elm = $element.find('.elm');

            var $activePanel = $gfLeftSideBar
              .data('gfleftsidebar')
              .showMDSettingsPanel('element', mdHtml, $element.attr('id'), eId);
            var fields = mdSettings;

            var $settingsPanel = $gfLeftSideBar.find('#md-submit .md-body.settings-panel');
            $settingsPanel.gfFormRender({
              fields: fields,
              onRender: function () {},
            });

            renderTabSettings.initGlobalStyle(type);

            // reload Tabs
            $gfTabs = $activePanel.find('.simple-tabs');
            $gfTabs.gfTabs({
              targetElement: $self,
              onSettingsChanged: function ($input) {
                saveSettings($input);
              },
              onTabClick: function (tabName) {
                switch (tabName) {
                  case 'Settings':
                    var $settingsPanel = $activePanel.find('.settings-panel');

                    $settingsPanel.find('.editLink').attr('value', $self.attr('href')).val($self.attr('href'));
                    $settingsPanel.find('.linkTarget').attr('value', $self.attr('target')).val($self.attr('target'));
                    $settingsPanel.find('.editText').attr('value', $self.html()).val($self.html());

                    var align = HELPER.getResponsiveAlign($elm, screenType);
                    $activePanel.find('.gf_to-align').attr('value', align).val(align).trigger('value-change');

                    var style = _this.getElementCSS();
                    var screenType =
                      $gfResTool.data('gfrestool') != undefined
                        ? $gfResTool.data('gfrestool').getCurrentStatus()
                        : 'lg';

                    var width = HELPER.getValueFromCSS($self, style, 'width', screenType);
                    var height = HELPER.getValueFromCSS($self, style, 'height', screenType);

                    var btnColor = HELPER.getValueFromCSS($self, style, 'background-color', screenType);
                    /* Not getting from browser css to avoid css overwriting problem from default theme */

                    var color = HELPER.getValueFromCSS($self, style, 'color', screenType);
                    /* Not getting from browser css to avoid css overwriting problem from default theme */

                    var btnColorHover = HELPER.getValueFromCSS(
                      $self,
                      style,
                      'background-color',
                      screenType,
                      eClass + ':hover',
                    );
                    /* Not getting from browser css to avoid css overwriting problem from default theme */

                    var colorHover = HELPER.getValueFromCSS($self, style, 'color', screenType, eClass + ':hover');
                    /* Not getting from browser css to avoid css overwriting problem from default theme */

                    var fontFamily = HELPER.getValueFromCSS($self, style, 'font-family', screenType);
                    if (!checkKeyValid('blockGetFontFamilyFromTheme')) {
                      if (fontFamily == '') {
                        fontFamily = $self.css('font-family');
                      }
                    }
                    var fontSize = HELPER.getValueFromCSS($self, style, 'font-size', screenType);
                    if (fontSize == '') {
                      fontSize = $self.css('font-size');
                    }
                    // set width height + fontsize
                    $activePanel.find('#button-color').attr('value', btnColor).val(btnColor).trigger('value-change');
                    $activePanel.find('#text-color').attr('value', color).val(color).trigger('value-change');
                    if (btnColorHover != '' || colorHover != '') {
                      $activePanel.find('#buttonHover').attr('value', 1).val(1).trigger('value-change');
                    } else {
                      $activePanel.find('#buttonHover').attr('value', 0).val(0).trigger('value-change');
                    }
                    $activePanel
                      .find('#button-color-hover')
                      .attr('value', btnColorHover)
                      .val(btnColorHover)
                      .trigger('value-change');
                    $activePanel
                      .find('#text-color-hover')
                      .attr('value', colorHover)
                      .val(colorHover)
                      .trigger('value-change');

                    //custom stretch
                    const attrStretch = 'data-stretch-' + screenType;
                    let stretch = $elm.attr(attrStretch);

                    if (!stretch) {
                      for (let i = 0; i < fields.length; i++) {
                        if (fields[i].name == 'stretch') {
                          stretch = fields[i].default_value;
                        }
                      }
                    }

                    if (stretch) {
                      $activePanel.find('#stretch').attr('value', stretch).val(stretch).trigger('value-change');
                    } else {
                      $activePanel.find('#stretch').attr('value', 0).val(0).trigger('value-change');
                    }

                    $activePanel.find('.width').attr('value', width).val(width).trigger('value-change');
                    $activePanel.find('.height').attr('value', height).val(height).trigger('value-change');

                    $activePanel.find('.gf_font').attr('value', fontFamily).val(fontFamily);
                    $activePanel.find('#font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

                    var extraClass = $self.attr('data-exc');
                    if (!extraClass) extraClass = '';
                    $activePanel.find('input[name="extra_class"]').attr('value', extraClass).val(extraClass);
                    setFontWeight({ $activePanel, $self, style, screenType });
                    // Get class global style
                    renderTabSettings.applySettingSnipetGlobalStyle(type, _this.getElementTargetId());
                    break;

                  case 'Design':
                    if ($gfTabs.data('gftabs') != undefined) {
                      $gfTabs.data('gftabs').onDesignOptionsTabClick();
                    }
                    break;
                }
                setTimeout(function () {
                  // capture history setting
                  if (capture != false) {
                    $gryffEditor.data('gfhistory').captureMERSettings();
                  }
                }, 100);
              },
            });

            var saveSettings = function ($input) {
              validateInput($input);
              const _addClass = [],
                _removeClass = []; // addClass/removeClass/css $self class

              const screenType =
                $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
              let style = _this.getElementCSS();

              // Apply setting style
              const $settingsPanel = $activePanel.find('.settings-panel');
              $self.html($settingsPanel.find('.editText').attr('value'));

              $self
                .attr('href', $settingsPanel.find('.editLink').attr('value'))
                .attr('target', $settingsPanel.find('.linkTarget').attr('value'));

              //Button align
              const align = $activePanel.find('.gf_to-align').attr('value');
              HELPER.setResponsiveAlign(align, $elm, screenType);

              // width & height
              if (
                ($self.css('paddingTop') != '0px' || $self.css('paddingBottom') != '0px') &&
                $self[0].style.height != $activePanel.find('.height').attr('value')
              ) {
                $self.css({
                  paddingTop: '0px',
                  paddingBottom: '0px',
                });
              }

              //custom stretch
              const attrStretch = 'data-stretch-' + screenType;
              $elm.attr(attrStretch, $settingsPanel.find('#stretch').attr('value'));

              var deOptions = [
                {
                  key: 'width',
                  value: $activePanel.find('.width').attr('value'),
                },
                {
                  key: 'height',
                  value: $activePanel.find('.height').attr('value'),
                },
                {
                  key: 'line-height',
                  value: $activePanel.find('.height').attr('value'),
                },
                {
                  key: 'font-family',
                  value: $activePanel.find('.gf_font').attr('value'),
                },
                {
                  key: 'font-size',
                  value: $activePanel.find('#font-size').attr('value'),
                },
                {
                  key: 'background-color',
                  value: $activePanel.find('#button-color').attr('value'),
                },
                {
                  key: 'color',
                  value: $activePanel.find('#text-color').attr('value'),
                },
                getFontWeightDesignOption({ $activePanel }),
              ];
              style = HELPER.designOptions2Style($element, screenType, style, deOptions);

              ////////// Set CSS style
              _this.setElementCSS(style);

              ///////// Set CSS style hover
              if ($activePanel.find('#buttonHover').val() == 1) {
                var bgColorHover = $activePanel.find('#button-color-hover').attr('value');
                var colorHover = $activePanel.find('#text-color-hover').attr('value');
              } else {
                var bgColorHover = '';
                var colorHover = '';
              }
              var deOptions = [
                {
                  key: 'background-color',
                  value: bgColorHover,
                },
                {
                  key: 'color',
                  value: colorHover,
                },
              ];
              style = HELPER.designOptions2Style($element, screenType, style, deOptions, eClass + ':hover');
              _this.setElementCSS(style);

              let oExClass = $self.attr('data-exc');
              if (!oExClass) oExClass = '';
              const nExClass = $activePanel
                .find('input[name="extra_class"]')
                .attr('value')
                .replace(/[^a-z0-9_\-\ ]/gi, '');
              _addClass.push(nExClass);
              _removeClass.push(oExClass);
              $self.attr('data-exc', nExClass);

              $self.removeClass(_removeClass.join(' ')).addClass(_addClass.join(' '));

              //----------------------

              HELPER.flagListItemChange($element, 'settings');

              const $itemContent = $element.closest('.item-content');
              HELPER.detectContentChange($itemContent);

              // Add class global style

              return false;
            };

            renderTabSettings.visibleSettingGlobalStyle(type);
            break;

          case 'icon':
            const ICON_FONT_AWESOME = 1;
            const versionIcon =
              typeof $element.attr('data-ver') !== 'undefined'
                ? parseInt($element.attr('data-ver'))
                : ICON_FONT_AWESOME;
            var $elm = $element.find('.elm');
            var $self = $element.find(eClass);

            var $activePanel = $gfLeftSideBar
              .data('gfleftsidebar')
              .showMDSettingsPanel('element', mdHtml, $element.attr('id'), eId);
            var fields = mdSettings;

            var $settingsPanel = $gfLeftSideBar.find('#md-icon .md-body.settings-panel');
            $settingsPanel.gfFormRender({
              fields: fields,
              onRender: function () {},
            });

            // reload Tabs
            $gfTabs = $activePanel.find('.simple-tabs');
            $gfTabs.gfTabs({
              targetElement: $self,
              onSettingsChanged: function ($input) {
                saveSettings($input);
              },
              onTabClick: function (tabName) {
                switch (tabName) {
                  case 'Settings':
                    var $stPanel = $activePanel.find('.settings-panel');
                    var $icon = $self.find('.gf_icon');

                    var icon = jQuery('<div/>').append($icon.clone()).html();
                    $stPanel.find('#choose-icon').attr('value', HELPER.base64UrlEncode(icon));

                    var style = _this.getElementCSS();
                    var screenType =
                      $gfResTool.data('gfrestool') != undefined
                        ? $gfResTool.data('gfrestool').getCurrentStatus()
                        : 'lg';

                    // color
                    var iconColor = HELPER.getValueFromCSS($self, style, 'color', screenType);
                    if (iconColor == '') {
                      iconColor = $self.css('color');
                    }
                    $stPanel.find('#icon-color').attr('value', iconColor).val(iconColor);

                    const sizeByVersion = versionIcon == ICON_FONT_AWESOME ? 'font-size' : 'width';
                    var iconSize = HELPER.getValueFromCSS($self, style, sizeByVersion, screenType);
                    if (iconSize == '') {
                      iconSize = $self.css(sizeByVersion);
                    }

                    iconSize = HELPER.convertToValueAndUnit(iconSize);
                    $stPanel
                      .find('#icon-size')
                      .val(iconSize.value)
                      .attr('value', iconSize.value)
                      .trigger('value-change');

                    var align = HELPER.getResponsiveAlign($elm, screenType);
                    $activePanel.find('.gf_to-align').attr('value', align).val(align).trigger('value-change');

                    var iconUrl = $element.find('.elm a').attr('href') || '';
                    $stPanel.find('.editLink').attr('value', iconUrl).val(iconUrl).trigger('value-change');

                    var target = $element.find('.elm a').attr('target');
                    $stPanel.find('#icon-target').attr('value', target).val(target);

                    $activePanel
                      .find('.gficon')
                      .off('click')
                      .on('click', function () {
                        $activePanel.find('.gficon').removeClass('active');
                        jQuery(this).addClass('active is-selected');
                      });

                    var extraClass = $element.find('.elm').attr('data-exc')
                      ? $element.find('.elm').attr('data-exc')
                      : '';
                    $activePanel.find('input[name="extra_class"]').attr('value', extraClass).val(extraClass);
                    break;
                  case 'Design':
                    if ($gfTabs.data('gftabs') != undefined) {
                      $gfTabs.data('gftabs').onDesignOptionsTabClick();
                    }
                    break;
                }
                setTimeout(function () {
                  // capture history setting
                  if (capture != false) {
                    $gryffEditor.data('gfhistory').captureMERSettings();
                  }
                }, 100);
              },
            });

            // show modal
            var saveSettings = function ($input) {
              validateInput($input);
              const $stPanel = $activePanel.find('.settings-panel');
              const icon = HELPER.base64UrlDecode($stPanel.find('#choose-icon').attr('value'));
              $self.html(icon);

              // Do not set style inline
              // $element.find('.gf_icon-wrap')
              //   .css({
              //     'color': $stPanel.find('#icon-color').attr('value')
              //   });

              // font-size
              let style = _this.getElementCSS();
              const screenType =
                $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';

              const deOptions = [
                {
                  key: 'color',
                  value: $activePanel.find('#icon-color').attr('value'),
                },
              ];
              if (versionIcon == ICON_FONT_AWESOME) {
                deOptions.push({
                  key: 'font-size',
                  value: $stPanel.find('#icon-size').attr('value'),
                });
              } else {
                deOptions.push({
                  key: 'width',
                  value: $stPanel.find('#icon-size').attr('value'),
                });
              }
              style = HELPER.designOptions2Style($element, screenType, style, deOptions);
              _this.setElementCSS(style);

              let mixSize = $stPanel.find('#bicon-size').attr('value');
              if (mixSize) {
                mixSize = mixSize.replace(/ +(?= )/g, '').split(' ');
                if (mixSize.length) {
                  $element.find('.gf_icon-wrap').css('width', mixSize[0]);
                  mixSize.length === 1
                    ? $element.find('.gf_icon-wrap').css('height', mixSize[0])
                    : $element.find('.gf_icon-wrap').css('height', mixSize[1]);
                }
              }

              const wraptype = $stPanel.find('#icon-align-background').attr('value');
              $element
                .find('.gf_icon-wrap')
                .removeClass('circle square rounded outline-circle outline-square outline-rounded')
                .addClass(wraptype);

              const align = $stPanel.find('#icon-align').attr('value');
              HELPER.setResponsiveAlign(align, $elm, screenType);

              const iconLink = $stPanel.find('input[name="editLink"]').attr('value').trim();
              if (iconLink) {
                //neu co the a thi thay href, ko thi boc them the a
                if ($element.find('.elm a').length) {
                  $element.find('.elm a').attr('href', iconLink);
                } else {
                  $element.find('.gf_icon-wrap').wrap('<a href="' + iconLink + '"></a>');
                }
                $element.find('.elm a').attr('target', $stPanel.find('#icon-target').attr('value'));
              } else {
                //Khong dat url thi xoa the a
                $element.find('.gf_icon-wrap').unwrap('a');
              }

              const oExClass = $element.find('.elm').attr('data-exc') ? $element.find('.elm').attr('data-exc') : '';
              const nExClass = $stPanel
                .find('input[name="extra_class"]')
                .attr('value')
                .replace(/[^a-z0-9_\-\ ]/gi, '');
              $element.find('.elm').removeClass(oExClass).addClass(nExClass).attr('data-exc', nExClass);

              //----------------------

              HELPER.flagListItemChange($element, 'settings');

              const $itemContent = $element.closest('.item-content');
              HELPER.detectContentChange($itemContent);

              return false;
            };
            break;

          case 'image':
            var $elm = $element.find('.elm');
            var $self = $element.find(eClass);

            var $activePanel = $gfLeftSideBar
              .data('gfleftsidebar')
              .showMDSettingsPanel('element', mdHtml, $element.attr('id'), eId);
            var fields = mdSettings;

            var $settingsPanel = $gfLeftSideBar.find('#md-image .md-body.settings-panel');
            $settingsPanel.gfFormRender({
              fields: fields,
              onRender: function () {},
            });

            // reload Tabs
            $gfTabs = $activePanel.find('.simple-tabs');
            $gfTabs.gfTabs({
              targetElement: $self,
              onSettingsChanged: function ($input) {
                saveSettings($input);
              },
              onTabClick: function (tabName) {
                switch (tabName) {
                  case 'Settings':
                    var src = $elm.find('img').attr('src');
                    $activePanel.find('input[name="image"]').attr('value', src).val(src);

                    var style = _this.getElementCSS();
                    var screenType =
                      $gfResTool.data('gfrestool') != undefined
                        ? $gfResTool.data('gfrestool').getCurrentStatus()
                        : 'lg';

                    var width = HELPER.getValueFromCSS($self, style, 'width', screenType);
                    if (width == '') {
                      width = 'auto';
                    }

                    var height = HELPER.getValueFromCSS($self, style, 'height', screenType);
                    if (height == '') {
                      height = 'auto';
                    }

                    var borderRadius = HELPER.getValueFromCSS($self, style, 'border-radius', screenType);
                    if (borderRadius == '100%') {
                      borderRadius = '1';
                    } else {
                      borderRadius = '0';
                    }
                    $activePanel.find('#circle').attr('value', borderRadius).val(borderRadius).trigger('value-change');

                    // set image resolution
                    const imgResolution = $element.attr('data-resolution') || '3000x3000';
                    $activePanel
                      .find('select[name="image-size"]')
                      .attr('value', imgResolution)
                      .val(imgResolution)
                      .trigger('value-change');

                    // set width height
                    $activePanel.find('#width').attr('value', width).val(width).trigger('value-change');
                    $activePanel.find('#height').attr('value', height).val(height).trigger('value-change');

                    $activePanel
                      .find('input[name="editLink"]')
                      .attr('value', $elm.find('a').attr('href'))
                      .val($elm.find('a').attr('href'));
                    // Set image target
                    $activePanel
                      .find('#url-target')
                      .attr('value', $elm.find('a').attr('target'))
                      .val($elm.find('a').attr('target'));

                    var align = HELPER.getResponsiveAlign($elm, screenType);
                    $activePanel.find('.gf_to-align').attr('value', align).val(align).trigger('value-change');

                    var altTag = $elm.find('img').attr('alt');
                    if (!altTag) {
                      altTag = '';
                    }
                    $activePanel.find('input[name="alt-tag"]').attr('value', altTag).val(altTag);

                    //add title
                    let titleTag = $elm.find('img').attr('title');
                    if (!titleTag) {
                      titleTag = '';
                    }
                    $activePanel.find('input[name="title"]').attr('value', titleTag).val(titleTag);

                    // Set extra class
                    var extraClass = $element.find('.elm').attr('data-exc');

                    if (!extraClass) extraClass = '';
                    $activePanel.find('input[name="extra_class"]').attr('value', extraClass).val(extraClass);
                    break;

                  case 'Design':
                    if ($gfTabs.data('gftabs') != undefined) {
                      $gfTabs.data('gftabs').onDesignOptionsTabClick();
                    }
                    break;
                }
                setTimeout(function () {
                  // capture history setting
                  if (capture != false) {
                    $gryffEditor.data('gfhistory').captureMERSettings();
                  }
                }, 100);
              },
            });

            // Tính toán width & height khi kéo element từ leftsiderbar
            const target = '.elm img';
            initSizeForElement($element, target);

            // show modal
            var saveSettings = function ($input) {
              validateInput($input);
              let imgSrc = $activePanel.find('input[name="image"]').attr('value');
              const imgWidth = $activePanel.find('#width').attr('value');
              const imgHeight = $activePanel.find('#height').attr('value');

              const imgResolution = $activePanel.find('#image-size').attr('value');

              if (imgWidth.indexOf('px') != -1 && imgHeight.indexOf('px') != -1) {
                imgSrc = HELPER.changeImageResolution(imgSrc, Math.max(parseInt(imgWidth), parseInt(imgHeight)));
              }

              /**
               * GIF Uploadcare return the url without size filter like this:
               * https://ucarecdn.com/884ec189-bd22-4793-9323-fc4078ef2218/
               * so do not add resolution to this url
               */
              const isGifUcare = hasImageUploadCare(imgSrc) && !imgSrc.includes('preview/');

              /**
               * Ignore svg image from shopify cdn
               */
              const imgExtension = getFileExtensionFromSource(imgSrc);
              const isSvgShopifyCDN = hasImageShopify(imgSrc) && imgExtension == 'svg';
              if (!(isGifUcare || isSvgShopifyCDN)) {
                imgSrc = replaceImageToSize(imgSrc, imgResolution);
                $element.attr('data-resolution', imgResolution);
                $activePanel.find('input[name="image"]').attr('value', imgSrc).trigger('value-change');
              }

              // save stuffs
              const $elemntImg = $element.find('.elm img');
              $elemntImg.on('load', function (e) {
                if (e.target.naturalWidth && e.target.naturalHeight) {
                  $(this).attr('natural-width', e.target.naturalWidth);
                  $(this).attr('natural-height', e.target.naturalHeight);
                }
              });
              const target = '.elm img';
              initSizeForElement($element, target);
              $elemntImg.attr('src', imgSrc);

              $elemntImg.attr('data-width', imgWidth).attr('data-height', imgHeight);

              let style = _this.getElementCSS();
              const screenType =
                $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';

              const deOptions = [
                {
                  key: 'width',
                  value: imgWidth,
                },
                {
                  key: 'height',
                  value: imgHeight,
                },
              ];

              const circleImageVal = $activePanel.find('#circle').attr('value');
              const isCircleImage = circleImageVal && circleImageVal == '1';
              const designTabBorderRadius = HELPER.getValueFromCSS(
                $elemntImg,
                style,
                'border-radius',
                screenType,
                targetClass,
              );

              if (isCircleImage) {
                deOptions.push({
                  key: 'border-radius',
                  value: '100%',
                });
              } else {
                deOptions.push({
                  key: 'border-radius',
                  value: designTabBorderRadius && designTabBorderRadius != '100%' ? designTabBorderRadius : '',
                });
              }

              style = HELPER.designOptions2Style($element, screenType, style, deOptions);
              _this.setElementCSS(style);

              // set alignment
              const align = $activePanel.find('select[name="alignment"]').attr('value');
              HELPER.setResponsiveAlign(align, $elm, screenType);

              // set url + target
              if ($activePanel.find('input[name="editLink"]').attr('value') != '') {
                let $a = $elm.find('img').parentsUntil($element, 'a');
                if ($a.length) {
                  $a.attr('href', $activePanel.find('input[name="editLink"]').attr('value')).attr(
                    'target',
                    $activePanel.find('#url-target').attr('value'),
                  );
                } else {
                  $elm
                    .find('img')
                    .wrap(
                      '<a href="' +
                        $activePanel.find('input[name="editLink"]').attr('value') +
                        '" target="' +
                        $activePanel.find('#url-target').attr('value') +
                        '"></a>',
                    );
                }
                $a = $elm.find('img').parentsUntil($element, 'a');
                $a.on('click', function (e) {
                  e.preventDefault();
                });
              } else {
                $elm.find('img').unwrap('a');
              }

              //Extra class
              const altTag = $activePanel.find('input[name="alt-tag"]').attr('value');
              $elm.find('img').attr('alt', altTag);

              const titleTag = $activePanel.find('input[name="title"]').attr('value');
              $elm.find('img').attr('title', titleTag);

              //Extra class
              let oExClass = $elm.attr('data-exc');
              if (!oExClass) oExClass = '';
              const nExClass = $activePanel
                .find('input[name="extra_class"]')
                .attr('value')
                .replace(/[^a-z0-9_\-\ ]/gi, '');
              $element.find('.elm').removeClass(oExClass).addClass(nExClass).attr('data-exc', nExClass);

              //----------------------

              HELPER.flagListItemChange($element, 'settings');

              const $itemContent = $element.closest('.item-content');
              HELPER.detectContentChange($itemContent);

              return false;
            };

            break;

          case 'separator':
            var $elm = $element.find('.elm');
            var $self = $element.find(eClass);

            var $activePanel = $gfLeftSideBar
              .data('gfleftsidebar')
              .showMDSettingsPanel('element', mdHtml, $element.attr('id'), eId);
            var fields = mdSettings;

            var $settingsPanel = $gfLeftSideBar.find('#md-separator .md-body.settings-panel');
            $settingsPanel.gfFormRender({
              fields: fields,
              onRender: function () {},
            });

            // reload Tabs
            $gfTabs = $activePanel.find('.simple-tabs');
            $gfTabs.gfTabs({
              targetElement: $self,
              onSettingsChanged: function ($input) {
                saveSettings($input);
              },
              onTabClick: function (tabName) {
                switch (tabName) {
                  case 'Settings':
                    var style = _this.getElementCSS();
                    var screenType =
                      $gfResTool.data('gfrestool') != undefined
                        ? $gfResTool.data('gfrestool').getCurrentStatus()
                        : 'lg';

                    var borderColor = HELPER.getValueFromCSS($self, style, 'border-color', screenType);
                    if (borderColor == '') {
                      borderColor = $self.css('border-top-color');
                    }
                    $activePanel
                      .find('#separator-color')
                      .attr('value', borderColor)
                      .val(borderColor)
                      .trigger('value-change');

                    var borderStyle = HELPER.getValueFromCSS($self, style, 'border-top-style', screenType);
                    if (borderStyle == '') {
                      borderStyle = $self.css('border-top-style');
                    }
                    $activePanel
                      .find('#separator-type')
                      .attr('value', borderStyle)
                      .val(borderStyle)
                      .trigger('value-change');

                    var width = HELPER.getValueFromCSS($self, style, 'width', screenType);
                    if (width == '') {
                      width = (parseFloat($self.css('width')) / $gryffEditor.width()) * 100;
                      width += '%';
                    }
                    var height = HELPER.getValueFromCSS($self, style, 'border-top-width', screenType);
                    if (height == '') {
                      height = $self.css('border-top-width');
                    }

                    $activePanel.find('#width').attr('value', width).val(width).trigger('value-change');

                    height = HELPER.convertToValueAndUnit(height);
                    $activePanel.find('#height').attr('value', height.value).val(height.value);
                    if (height.unit) {
                      $activePanel.find('#height').attr('unit', height.unit).trigger('value-change');
                    }

                    var align = HELPER.getResponsiveAlign($elm, screenType);
                    $activePanel.find('.gf_to-align').attr('value', align).val(align).trigger('value-change');

                    // Set extra class
                    var extraClass = $elm.attr('data-exc');
                    if (!extraClass) extraClass = '';
                    $activePanel.find('input[name="extra_class"]').attr('value', extraClass).val(extraClass);

                    break;

                  case 'Design':
                    if ($gfTabs.data('gftabs') != undefined) {
                      $gfTabs.data('gftabs').onDesignOptionsTabClick();
                    }
                    break;
                }
                setTimeout(function () {
                  // capture history setting
                  if (capture != false) {
                    $gryffEditor.data('gfhistory').captureMERSettings();
                  }
                }, 100);
              },
            });

            var saveSettings = function ($input) {
              validateInput($input);
              let style = _this.getElementCSS();
              const screenType =
                $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';

              const borderColor = $activePanel.find('#separator-color').attr('value');

              let borderStyle = $activePanel.find('#separator-type').attr('value');
              if (borderStyle == '') {
                borderStyle = 'solid';
              }
              const deOptions = [
                {
                  key: 'border-style',
                  value: borderStyle,
                },
                {
                  key: 'border-color',
                  value: borderColor,
                },
                {
                  key: 'width',
                  value: $activePanel.find('#width').attr('value'),
                },
                {
                  key: 'border-top-width',
                  value: $activePanel.find('#height').attr('value'),
                },
                {
                  key: 'border-right-width',
                  value: '0px',
                },
                {
                  key: 'border-bottom-width',
                  value: '0px',
                },
                {
                  key: 'border-left-width',
                  value: '0px',
                },
                getFontWeightDesignOption({ $activePanel }),
              ];
              style = HELPER.designOptions2Style($element, screenType, style, deOptions);
              _this.setElementCSS(style);

              // set alignment
              const align = $activePanel.find('select[name="alignment"]').attr('value');
              HELPER.setResponsiveAlign(align, $elm, screenType);

              //Extra class
              let oExClass = $elm.attr('data-exc');
              if (!oExClass) oExClass = '';
              const nExClass = $activePanel
                .find('input[name="extra_class"]')
                .attr('value')
                .replace(/[^a-z0-9_\-\ ]/gi, '');

              $elm.removeClass(oExClass).addClass(nExClass).attr('data-exc', nExClass);

              //----------------------

              // Product List detect child change 3
              // Article List detect child change 3
              HELPER.flagListItemChange($element, 'settings');

              const $itemContent = $element.closest('.item-content');
              HELPER.detectContentChange($itemContent);

              return false;
            };
            break;

          case 'text-field':
          case 'email-field':
          case 'text-area':
            var $self = $element.find(eClass);
            if (type == 'textarea') {
              var $self = $element.find('textarea');
            } else {
              var $elm = $element.find('.elm');
            }
            var $activePanel = $gfLeftSideBar
              .data('gfleftsidebar')
              .showMDSettingsPanel('element', mdHtml, $element.attr('id'), eId);
            var fields = mdSettings;

            switch ($activePanel.attr('id')) {
              case 'md-email-field':
                var $settingsPanel = $gfLeftSideBar.find('#md-email-field .md-body.settings-panel');
                break;
              case 'md-text-area':
                var $settingsPanel = $gfLeftSideBar.find('#md-text-area .md-body.settings-panel');
                break;
              case 'md-text-field':
                var $settingsPanel = $gfLeftSideBar.find('#md-text-field .md-body.settings-panel');
                break;
            }

            $settingsPanel.gfFormRender({
              fields: fields,
              onRender: function () {},
            });

            renderTabSettings.initGlobalStyle(type);

            // reload Tabs
            $gfTabs = $activePanel.find('.simple-tabs');
            $gfTabs.gfTabs({
              targetElement: $self,
              onSettingsChanged: function ($input) {
                saveSettings($input);
              },
              onTabClick: function (tabName) {
                switch (tabName) {
                  case 'Settings':
                    // Loại bỏ phần contact[] của contacform;
                    if ($self.closest('[data-label="Contact Form"]').length > 0) {
                      var name = $self.attr('name');
                      // Không loại bỏ nữa

                      // name = name.replace('contact[','');
                      // name = name.replace(']','');
                    } else {
                      var name = $self.attr('name');
                    }
                    if ($self.closest('[data-label="Contact Form"]').length > 0) {
                      if ($self.closest('[data-label="Email Field"]').length > 0) {
                        $activePanel.find('.name').attr('readonly', 'true');
                        $activePanel
                          .find('.name')
                          .attr(
                            'data-description',
                            '<svg fill="#FFC439" height="14px" viewBox="0 0 24 24" width="14px" style="position: relative;top: 2px;"><path d="M0 0h24v24H0z" fill="none"></path><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path></svg> You cannot change this field name',
                          );
                      }
                    }
                    if ($self.closest('[data-label="Newsletter"]').length > 0) {
                      if ($self.closest('[data-label="Email Field"]').length > 0) {
                        $activePanel.find('.name').attr('readonly', 'true');
                        $activePanel
                          .find('.name')
                          .attr(
                            'data-description',
                            '<svg fill="#FFC439" height="14px" viewBox="0 0 24 24" width="14px" style="position: relative;top: 2px;"><path d="M0 0h24v24H0z" fill="none"></path><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path></svg> You cannot change this field name',
                          );
                      }
                    }
                    if ($self.closest('[data-label="Mailchimp"]').length > 0) {
                      if ($self.closest('[data-label="Email Field"]').length > 0) {
                        $activePanel.find('.name').attr('readonly', 'true');
                        $activePanel
                          .find('.name')
                          .attr(
                            'data-description',
                            '<svg fill="#FFC439" height="14px" viewBox="0 0 24 24" width="14px" style="position: relative;top: 2px;><path d="M0 0h24v24H0z" fill="none"></path><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path></svg> You cannot change this field name',
                          );
                      }
                    }

                    $activePanel.find('.name').attr('value', name).val(name);
                    $activePanel
                      .find('.placeholder')
                      .attr('value', $self.attr('placeholder'))
                      .val($self.attr('placeholder'));

                    var required = $self.attr('required') != undefined ? 1 : 0;
                    $activePanel.find('[name="required"]').attr('value', required).val(required);

                    var style = _this.getElementCSS();
                    var screenType =
                      $gfResTool.data('gfrestool') != undefined
                        ? $gfResTool.data('gfrestool').getCurrentStatus()
                        : 'lg';

                    var width = HELPER.getValueFromCSS($self, style, 'width', screenType);
                    var height = HELPER.getValueFromCSS($self, style, 'height', screenType);
                    var color = HELPER.getValueFromCSS($self, style, 'color', screenType);
                    if (color == '') {
                      color = HELPER.rgb2hex($self.css('color'));
                    }
                    var fontFamily = HELPER.getValueFromCSS($self, style, 'font-family', screenType);
                    if (!checkKeyValid('blockGetFontFamilyFromTheme')) {
                      if (fontFamily == '') {
                        fontFamily = $self.css('font-family');
                      }
                    }
                    var fontSize = HELPER.getValueFromCSS($self, style, 'font-size', screenType);
                    if (fontSize == '') {
                      fontSize = $self.css('font-size');
                    }

                    // set width height + fontsize
                    $activePanel.find('#text-color').attr('value', color).val(color);

                    width = HELPER.convertToValueAndUnit(width);
                    $activePanel.find('.width').attr('value', width.value).val(width.value);
                    if (width.unit) {
                      $activePanel.find('.width').attr('unit', width.unit).trigger('value-change');
                    }

                    height = HELPER.convertToValueAndUnit(height);
                    $activePanel.find('.height').attr('value', height.value).val(height.value);
                    if (height.unit) {
                      $activePanel.find('.height').attr('unit', height.unit).trigger('value-change');
                    }

                    $activePanel.find('.gf_font').attr('value', fontFamily).val(fontFamily);
                    $activePanel.find('#font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

                    var align = HELPER.getResponsiveAlign($elm, screenType);
                    $activePanel.find('.gf_to-align').attr('value', align).val(align).trigger('value-change');

                    // Hide on Client
                    if (type == 'email-field') {
                      var isHideOnClient = $self.attr('hide');
                      const value = $self.attr('value');
                      $activePanel.find('#defaultvalue').attr('value', value).val(value);
                      if (isHideOnClient == 'true') {
                        $activePanel.find('#hideOnClient').attr('value', 1).val(1);
                      } else {
                        $activePanel.find('#hideOnClient').attr('value', 0).val(0);
                      }
                    }

                    // Set extra class
                    var extraClass = $self.attr('data-exc');
                    if (!extraClass) extraClass = '';
                    $activePanel.find('input[name="extra_class"]').attr('value', extraClass).val(extraClass);
                    setFontWeight({ $activePanel, $self, style, screenType });
                    // Get class global style
                    renderTabSettings.applySettingSnipetGlobalStyle(type, _this.getElementTargetId());
                    break;

                  case 'Design':
                    if ($gfTabs.data('gftabs') != undefined) {
                      $gfTabs.data('gftabs').onDesignOptionsTabClick();
                    }
                    break;
                }
                setTimeout(function () {
                  // capture history setting
                  if (capture != false) {
                    $gryffEditor.data('gfhistory').captureMERSettings();
                  }
                }, 100);
              },
            });

            // show modal
            var saveSettings = function ($input) {
              validateInput($input);
              const screenType =
                $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
              let style = _this.getElementCSS();

              $self
                .attr('name', $activePanel.find('.name').attr('value'))
                .attr('placeholder', $activePanel.find('.placeholder').attr('value'));

              if ($activePanel.find('[name="required"]').attr('value') == '1') {
                $self.attr('required', 'required');
              } else {
                $self.removeAttr('required');
              }

              const hideOnClient = $activePanel.find('[name="hideOnClient"]').attr('value');
              let defaultValue = '';
              let defaultEmailField = '';
              if (hideOnClient && hideOnClient == '1') {
                $self.attr('hide', 'true');
                defaultValue = $activePanel.find('[name="defaultvalue"]').attr('value');
                if (!defaultValue) {
                  defaultEmailField = window.___gemShopInfo.email;
                }
              } else {
                $self.attr('hide', 'false');
              }

              $self.attr('value', defaultValue || defaultEmailField).val(defaultValue || defaultEmailField);

              const deOptions = [
                {
                  key: 'width',
                  value: $activePanel.find('.width').attr('value'),
                },
                {
                  key: 'height',
                  value: $activePanel.find('.height').attr('value'),
                },
                {
                  key: 'font-size',
                  value: $activePanel.find('#font-size').attr('value'),
                },
                {
                  key: 'color',
                  value: $activePanel.find('#text-color').attr('value'),
                },
                {
                  key: 'font-family',
                  value: $activePanel.find('.gf_font').attr('value'),
                },
                getFontWeightDesignOption({ $activePanel }),
              ];
              if (type != 'text-area') {
                const data = {
                  key: 'line-height',
                  value: $activePanel.find('.height').attr('value'),
                };
                deOptions.push(data);
              }

              style = HELPER.designOptions2Style($element, screenType, style, deOptions);

              ////////// Set CSS style
              _this.setElementCSS(style);

              // set alignment
              const align = $activePanel.find('.gf_to-align').attr('value');
              HELPER.setResponsiveAlign(align, $elm, screenType);

              //Extra class
              let oExClass = $element.attr('data-exc');
              if (!oExClass) oExClass = '';
              const nExClass = $activePanel
                .find('input[name="extra_class"]')
                .attr('value')
                .replace(/[^a-z0-9_\-\ ]/gi, '');

              $self.removeClass(oExClass).addClass(nExClass).attr('data-exc', nExClass);

              //----------------------

              // Product List detect child change 3
              // Article List detect child change 3
              HELPER.flagListItemChange($element, 'settings');

              const $itemContent = $element.closest('.item-content');
              HELPER.detectContentChange($itemContent);

              // Add class global style

              return false;
            };
            renderTabSettings.visibleSettingGlobalStyle(type);
            break;

          case 'dropdown':
            var $elm = $element.find('.elm');
            var $self = $element.find(eClass);

            var $activePanel = $gfLeftSideBar
              .data('gfleftsidebar')
              .showMDSettingsPanel('element', mdHtml, $element.attr('id'), eId);
            var fields = mdSettings;
            var $settingsPanel = $gfLeftSideBar.find('#md-dropdown .md-body.settings-panel');

            $settingsPanel.gfFormRender({
              fields: fields,
              onRender: function () {},
            });

            renderTabSettings.initGlobalStyle(type);

            // reload Tabs
            $gfTabs = $activePanel.find('.simple-tabs');
            $gfTabs.gfTabs({
              targetElement: $self,
              onSettingsChanged: function ($input) {
                saveSettings($input);
              },
              onTabClick: function (tabName) {
                switch (tabName) {
                  case 'Settings':
                    // Loại bỏ phần contact[] của contacform;
                    if ($self.closest('[data-label="Contact Form"]').length > 0) {
                      var name = $self.attr('name');

                      // Không bỏ nữa
                      // name = name.replace('contact[','');
                      // name = name.replace(']','');
                    } else {
                      var name = $self.attr('name');
                    }

                    $activePanel.find('.name').attr('value', $self.attr('name')).val($self.attr('name'));

                    var options = [];
                    $self.find('option').each(function () {
                      const value = jQuery(this).attr('value') == null ? '' : jQuery(this).attr('value');
                      const text = jQuery(this).text();
                      options.push(value.trim() + ' => ' + text.trim());
                    });
                    options = options.join('\n');

                    //hotfix bằng cách replace " bằng &quot; ' bằng &apos;
                    if (options) {
                      options = replaceQuoteCharacter(options);
                    }

                    $activePanel.find('.options').attr('value', options).val(options);

                    var required = $self.attr('required') != undefined ? 1 : 0;
                    $activePanel.find('[name="required"]').attr('value', required).val(required);

                    var style = _this.getElementCSS();
                    var screenType =
                      $gfResTool.data('gfrestool') != undefined
                        ? $gfResTool.data('gfrestool').getCurrentStatus()
                        : 'lg';

                    var width = HELPER.getValueFromCSS($self, style, 'width', screenType);
                    var height = HELPER.getValueFromCSS($self, style, 'height', screenType);
                    var color = HELPER.getValueFromCSS($self, style, 'color', screenType);
                    if (color == '') {
                      color = HELPER.rgb2hex($self.css('color'));
                    }
                    var fontFamily = HELPER.getValueFromCSS($self, style, 'font-family', screenType);
                    if (!checkKeyValid('blockGetFontFamilyFromTheme')) {
                      if (fontFamily == '') {
                        fontFamily = $self.css('font-family');
                      }
                    }
                    var fontSize = HELPER.getValueFromCSS($self, style, 'font-size', screenType);
                    if (fontSize == '') {
                      fontSize = $self.css('font-size');
                    }

                    $activePanel.find('#text-color').attr('value', color).val(color);

                    width = HELPER.convertToValueAndUnit(width);
                    $activePanel.find('.width').attr('value', width.value).val(width.value);
                    if (width.unit) {
                      $activePanel.find('.width').attr('unit', width.unit).trigger('value-change');
                    }

                    height = HELPER.convertToValueAndUnit(height);
                    $activePanel.find('.height').attr('value', height.value).val(height.value);
                    if (height.unit) {
                      $activePanel.find('.height').attr('unit', height.unit).trigger('value-change');
                    }

                    $activePanel.find('.gf_font').attr('value', fontFamily).val(fontFamily);
                    $activePanel.find('#font-size').val(fontSize).attr('value', fontSize).trigger('value-change');

                    // alignment
                    var align = HELPER.getResponsiveAlign($elm, screenType);
                    $activePanel.find('.gf_to-align').attr('value', align).val(align).trigger('value-change');

                    // Set extra class
                    var extraClass = $self.attr('data-exc');
                    if (!extraClass) extraClass = '';
                    $activePanel.find('input[name="extra_class"]').attr('value', extraClass).val(extraClass);
                    setFontWeight({ $activePanel, $self, style, screenType });
                    // Get class global style
                    renderTabSettings.applySettingSnipetGlobalStyle(type, _this.getElementTargetId());
                    break;

                  case 'Design':
                    if ($gfTabs.data('gftabs') != undefined) {
                      $gfTabs.data('gftabs').onDesignOptionsTabClick();
                    }
                    break;
                }
                setTimeout(function () {
                  // capture history setting
                  if (capture != false) {
                    $gryffEditor.data('gfhistory').captureMERSettings();
                  }
                }, 100);
              },
            });

            var saveSettings = function ($input) {
              validateInput($input);
              const screenType =
                $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
              let style = _this.getElementCSS();

              $self.attr('name', $activePanel.find('.name').attr('value'));

              const options = $activePanel.find('.options').attr('value').split(/\n/);
              let htmlOptions = '';
              const newTxt = [];
              for (let i = 0; i < options.length; i++) {
                const arr = options[i].split('=>');
                if (arr.length == 2) {
                  let key = arr[1];
                  let value = arr[0];

                  //hotfix bằng cách replace " bằng &quot; ' bằng &apos;
                  if (key != null && key != '') {
                    key = replaceQuoteCharacter(key).trim();
                  }
                  if (value != null && value != '') {
                    value = replaceQuoteCharacter(value).trim();
                  }

                  newTxt.push(value + ' => ' + key);
                  htmlOptions += '<option value="' + value + '">' + key + '</option>';
                }
              }
              $self.html(htmlOptions);

              if ($activePanel.find('[name="required"]').attr('value') == '1') {
                $self.attr('required', 'required');
              } else {
                $self.removeAttr('required');
              }

              const deOptions = [
                {
                  key: 'color',
                  value: $activePanel.find('#text-color').attr('value'),
                },
                {
                  key: 'width',
                  value: $activePanel.find('.width').attr('value'),
                },
                {
                  key: 'height',
                  value: $activePanel.find('.height').attr('value'),
                },
                {
                  key: 'line-height',
                  value: $activePanel.find('.height').attr('value'),
                },
                {
                  key: 'font-family',
                  value: $activePanel.find('.gf_font').attr('value'),
                },
                {
                  key: 'font-size',
                  value: $activePanel.find('#font-size').attr('value'),
                },
                getFontWeightDesignOption({ $activePanel }),
              ];

              style = HELPER.designOptions2Style($element, screenType, style, deOptions);

              ////////// Set CSS style
              _this.setElementCSS(style);

              // set alignment
              const align = $activePanel.find('.gf_to-align').attr('value');
              HELPER.setResponsiveAlign(align, $elm, screenType);

              //Extra class
              let oExClass = $element.attr('data-exc');
              if (!oExClass) oExClass = '';
              const nExClass = $activePanel
                .find('input[name="extra_class"]')
                .attr('value')
                .replace(/[^a-z0-9_\-\ ]/gi, '');

              $self.removeClass(oExClass).addClass(nExClass).attr('data-exc', nExClass);

              //----------------------

              // Product List detect child change 3
              // Article List detect child change 3
              HELPER.flagListItemChange($element, 'settings');

              const $itemContent = $element.closest('.item-content');
              HELPER.detectContentChange($itemContent);

              // Add class global style

              return false;
            };
            renderTabSettings.visibleSettingGlobalStyle(type);
            break;

          case 'checkbox':
            var $self = $element.find(eClass);
            var $elm = $element.find('.elm');
            var $description = $self.next('span');

            var targetCheckboxClass = _this.getTargetClass();
            var targetClass = targetCheckboxClass + '~span';

            var $activePanel = $gfLeftSideBar
              .data('gfleftsidebar')
              .showMDSettingsPanel('element', mdHtml, $element.attr('id'), eId);
            var fields = mdSettings;

            var $settingsPanel = $gfLeftSideBar.find('#md-checkbox .md-body.settings-panel');
            $settingsPanel.gfFormRender({
              fields: fields,
              onRender: function () {
                // $settingsPanel.gfForm();
              },
            });

            renderTabSettings.initGlobalStyle(type);

            // reload Tabs
            $gfTabs = $activePanel.find('.simple-tabs');
            $gfTabs.gfTabs({
              targetElement: $self,
              onSettingsChanged: function ($input) {
                saveSettings($input);
              },
              onTabClick: function (tabName) {
                switch (tabName) {
                  case 'Settings':
                    // Loại bỏ phần contact[] của contacform;
                    if ($self.closest('[data-label="Contact Form"]').length > 0) {
                      var name = $self.attr('name');

                      // Không bỏ nữa
                      // name = name.replace('contact[','');
                      // name = name.replace(']','');
                    } else {
                      var name = $self.attr('name');
                    }

                    $activePanel.find('.name').attr('value', name).val(name);
                    $activePanel.find('#description').attr('value', $description.html()).val($description.html());

                    var required = $self.attr('required') != undefined ? 1 : 0;
                    $activePanel.find('[name="required"]').attr('value', required).val(required);

                    var selected = $self.attr('checked') != undefined ? 1 : 0;
                    $activePanel.find('[name="selected"]').attr('value', selected).val(selected);

                    var style = _this.getElementCSS();
                    var screenType =
                      $gfResTool.data('gfrestool') != undefined
                        ? $gfResTool.data('gfrestool').getCurrentStatus()
                        : 'lg';

                    var fontSize = HELPER.getValueFromCSS($element, style, 'font-size', screenType, targetClass);
                    if (fontSize == '') {
                      fontSize = parseFloat($description.css('font-size'));
                    }
                    $activePanel
                      .find('input[name="font-size"]')
                      .val(fontSize)
                      .attr('value', fontSize)
                      .trigger('value-change');

                    var lineHeight = HELPER.getValueFromCSS($element, style, 'line-height', screenType, targetClass);
                    if ($activePanel.find('#line-height').attr('unit') == 'em') {
                      if (lineHeight == '') {
                        lineHeight = parseFloat($description.css('line-height'));
                        lineHeight = lineHeight / parseFloat(fontSize);
                        lineHeight += 'em';
                      }
                      if (lineHeight.indexOf('px') !== -1) {
                        lineHeight = parseFloat(lineHeight);
                        lineHeight = lineHeight / parseFloat(fontSize);
                        lineHeight += 'em';
                      }
                    } else if ($activePanel.find('#line-height').attr('unit') == 'px') {
                      if (lineHeight == '') {
                        lineHeight = $description.css('line-height');
                      }
                      if (lineHeight.indexOf('em') !== -1) {
                        lineHeight = parseFloat(lineHeight);
                        lineHeight = fontSize * lineHeight;
                        lineHeight += 'px';
                      }
                    }
                    $activePanel
                      .find('input[name="line-height"]')
                      .val(lineHeight)
                      .attr('value', lineHeight)
                      .trigger('value-change');

                    var letterSpacing = HELPER.getValueFromCSS(
                      $element,
                      style,
                      'letter-spacing',
                      screenType,
                      targetClass,
                    );
                    if (letterSpacing == '') {
                      letterSpacing = parseFloat($description.css('letter-spacing'));
                    }
                    $activePanel
                      .find('input[name="letter-spacing"]')
                      .val(letterSpacing)
                      .attr('value', letterSpacing)
                      .trigger('value-change');

                    var fontFamily = HELPER.getValueFromCSS($element, style, 'font-family', screenType, targetClass);
                    // if(fontFamily == '') {
                    //     fontFamily = $description.css('font-family');
                    // }
                    fontFamily = jQuery.trim(fontFamily);
                    $activePanel
                      .find('input[name="font"]')
                      .val(fontFamily)
                      .attr('value', fontFamily)
                      .trigger('value-change');

                    var color = HELPER.getValueFromCSS($element, style, 'color', screenType);
                    if (color == '') {
                      color = HELPER.rgb2hex($description.css('color'));
                    }
                    $activePanel.find('input[name="color"]').val(color).attr('value', color).trigger('value-change');

                    // checkbox
                    var padding = HELPER.getValueFromCSS($element, style, 'padding', screenType, targetClass);
                    if (padding == '') {
                      padding = parseFloat($description.css('padding-left'));
                    }
                    $activePanel
                      .find('input[name="padding"]')
                      .val(padding)
                      .attr('value', padding)
                      .trigger('value-change');

                    var position = HELPER.getValueFromCSS($element, style, 'top', screenType, targetCheckboxClass);
                    if (position == '') {
                      position = parseFloat($self.css('top'));
                    }
                    $activePanel
                      .find('input[name="position"]')
                      .val(position)
                      .attr('value', position)
                      .trigger('value-change');

                    var align = HELPER.getResponsiveAlign($elm, screenType);
                    $activePanel.find('.gf_to-align').attr('value', align).val(align).trigger('value-change');

                    // Set extra class
                    var extraClass = $self.attr('data-exc');
                    if (!extraClass) extraClass = '';
                    $activePanel.find('input[name="extra_class"]').attr('value', extraClass).val(extraClass);

                    // Get class global style
                    renderTabSettings.applySettingSnipetGlobalStyle(type, _this.getElementTargetId());

                    break;

                  case 'Design':
                    if ($gfTabs.data('gftabs') != undefined) {
                      $gfTabs.data('gftabs').onDesignOptionsTabClick();
                    }
                    break;
                }
                setTimeout(function () {
                  // capture history setting
                  if (capture != false) {
                    $gryffEditor.data('gfhistory').captureMERSettings();
                  }
                }, 100);
              },
            });

            // show modal
            var saveSettings = function ($input) {
              validateInput($input);
              const screenType =
                $gfResTool.data('gfrestool') != undefined ? $gfResTool.data('gfrestool').getCurrentStatus() : 'lg';
              let style = _this.getElementCSS();

              $self.attr('name', $activePanel.find('.name').attr('value'));
              $description.html($activePanel.find('#description').attr('value'));

              if ($activePanel.find('[name="required"]').attr('value') == '1') {
                $self.attr('required', 'required');
              } else {
                $self.removeAttr('required');
              }

              if ($activePanel.find('[name="selected"]').attr('value') == '1') {
                $self.attr('checked', 'checked');
                $self.prop('checked', true);
              } else {
                $self.removeAttr('checked');
                $self.prop('checked', false);
              }

              var deOptions = [
                {
                  key: 'font-size',
                  value: $activePanel.find('input[name="font-size"]').val(),
                },
                {
                  key: 'line-height',
                  value: $activePanel.find('input[name="line-height"]').val(),
                },
                {
                  key: 'letter-spacing',
                  value: $activePanel.find('input[name="letter-spacing"]').val(),
                },
                {
                  key: 'font-family',
                  value: $activePanel.find('input[name="font"]').val(),
                },
                {
                  key: 'color',
                  value: $activePanel.find('input[name="color"]').val(),
                },
                {
                  key: 'padding-left',
                  value: $activePanel.find('input[name="padding"]').val(),
                },
                getFontWeightDesignOption({ $activePanel }),
              ];

              style = HELPER.designOptions2Style($element, screenType, style, deOptions, targetClass);

              var deOptions = [
                {
                  key: 'top',
                  value: $activePanel.find('input[name="position"]').val(),
                },
              ];
              style = HELPER.designOptions2Style($element, screenType, style, deOptions, targetCheckboxClass);

              ////////// Set CSS style
              _this.setElementCSS(style);

              // set alignment
              const align = $activePanel.find('.gf_to-align').attr('value');
              HELPER.setResponsiveAlign(align, $elm, screenType);

              //Extra class
              let oExClass = $element.attr('data-exc');
              if (!oExClass) oExClass = '';
              const nExClass = $activePanel
                .find('input[name="extra_class"]')
                .attr('value')
                .replace(/[^a-z0-9_\-\ ]/gi, '');

              $self.removeClass(oExClass).addClass(nExClass).attr('data-exc', nExClass);

              //----------------------

              // Product List detect child change 3
              // Article List detect child change 3
              HELPER.flagListItemChange($element, 'settings');

              const $itemContent = $element.closest('.item-content');
              HELPER.detectContentChange($itemContent);

              // Add class global style

              return false;
            };
            renderTabSettings.visibleSettingGlobalStyle(type);
            break;

          default:
            var $activeModal = jQuery('#md-unknown');
            $activeModal.gfModal().data('gfmodal').setWidth('300px').centerModal().show();

            break;
        }

        if (tab != undefined && tab == 'Design') {
          $gfTabs.data('gftabs').gotoTab(1);
        }

        if (columnOpen && columnOpen != '') {
          $gfLeftSideBar.find('.columns[data-caption="' + columnOpen + '"]').attr('data-toggle', 'true');
        }

        store.setValue('renderColumnEnd', '');

        app.$store.commit('sidebar/CHANGE_ACTIVE_TAB', {
          key: 'elements',
        });
      };
      // Execute function

      const presetIsEdited = app.$store.getters['sidebar/PRESET_IS_EDITED'];

      if (presetIsEdited) {
        emitter.emit('WithoutPresetEdited');
        emitter.on('CallBackWithoutPresetEdited', () => {
          doOpenElementSettings();
        });
      }

      if (presetIsEdited) return false;
      doOpenElementSettings();
      return false;
    };

    this.initElementTool = function () {
      if ($element.children('.gf-tool-wrap').length == 0) {
        const _eTool =
          '<ul class="gf-tool gf-e-tool gf-tool-wrap gf-e-tool-wrap"><li class="t-handle"><a class="e-handle"><span><svg class="editor move" width="14" viewBox="0 0 14 14"><path d="M11,10V8H8v3h2l-3,3l-3-3h2V8H3v2L0,7l3-3v2h3V3H4l3-3l3,3H8v3h3V4l3,3L11,10z"/></svg></span><span class="gf-tool-label">Element</span></a></li><li class="e-edit"><a class="e-edit"><svg class="need_a_name" height="14px" viewbox="0 0 14 14"><path d="M12.81,3.69c0.26-0.26,0.26-0.68,0-0.94l-1.56-1.56c-0.26-0.26-0.68-0.26-0.94,0L9.09,2.41l2.5,2.5L12.81,3.69zM1,10.5V13h2.5l7.37-7.37l-2.5-2.5L1,10.5z" /></svg></a></li><li class="t-wrap e-wrap"><a class="e-export" title="Save element"><svg class="editor save" width="14" height="14px" viewBox="0 0 14 14"><path d="M12.2499 9.78559V12.4106H1.74999V9.78559H0V12.4106C0 13.3731 0.787495 14.1606 1.74999 14.1606H12.2499C13.2124 14.1606 13.9999 13.3731 13.9999 12.4106V9.78559H12.2499ZM11.3749 6.28561L10.1412 5.05187L7.87495 7.30935V0.160645H6.12496V7.30935L3.85873 5.05187L2.62498 6.28561L6.99996 10.6606L11.3749 6.28561Z"/></svg></a><a class="e-clone" title="Clone Element"><svg class="editor duplicate" width="14" viewBox="0 0 14 14"><path d="M10,10H0V0h10V10z M12,4v8H4v2h10V4H12z"/></svg></a><a class="e-remove" title="Delete Element"><svg class="editor delete" width="14" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7c0,3.9,3.1,7,7,7s7-3.1,7-7C14,3.1,10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4 L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z"/></svg></a></li><li class="t-collapse"><a title="Expand / Collapse"><svg class="editor expand" width="8" viewBox="0 0 8 14"><path d="M1,3l4,4l-4,4V3z"/></svg></a></li></ul>';
        $element.append(_eTool);
      }
      // set handle name
      const elementName = $element.attr('data-label');
      const $eToolWrap = $element.children('.gf-tool-wrap');
      $eToolWrap.find('.e-handle span.gf-tool-label').text(elementName);

      $element.off('mouseleave.tool').on('mouseleave.tool', function (e) {
        if ($element.hasClass('element-wrap') && $element.data('gfelement') != undefined) {
          $element.data('gfelement').hideTool();
        }
      });

      return false;
    };

    // gfElement.applyEvents
    this.applyEvents = function () {
      // apply functions

      _this.initElementTool();
      _this.applyButtonActions();
      _this.applyDrag();
      // apply functions
      if ($element.data('gfoutline') != undefined) {
        $element.data('gfoutline').initOutline();
        $element.data('gfoutline').applyOutline();
      } else {
        $element.gfOutline({
          margin: true,
          padding: false,
        });
      }

      const elementName = $element.attr('data-label');
      switch (elementName) {
        case 'Icon':
          $element
            .find('.elm .gf_icon-wrap')
            .off()
            .on('click', function () {
              const $mdIcon = $('#md-icon');
              $element.on('value-change', function () {
                const icon = HELPER.base64UrlDecode($formElement.attr('value'));
                $mdIcon.children('.selected-icon').html(icon);
              });
              jQuery('<div/>').gfIconPicker({
                onSuccess: function (icon) {
                  $element.attr('value', HELPER.base64UrlEncode(icon)).trigger('input-change');
                  $element.trigger('history-change');
                  $element.find('.gf_icon-wrap').html(icon);
                  $mdIcon.find('.selected-icon').html(icon);
                  $mdIcon
                    .find('#choose-icon')
                    .val(HELPER.base64UrlEncode(icon))
                    .attr('value', HELPER.base64UrlEncode(icon));

                  // detect element or module change
                  const $itemContent = $element.closest('.item-content');
                  HELPER.detectContentChange($itemContent);
                },
              });
              return false;
            });
          break;

        case 'Checkbox':
          $element
            .find('.elm .gf_checkbox')
            .parent()
            .off('click')
            .on('click', function (e) {
              HELPER.showNotify('You can select the checkbox in live page only.', 'success');

              e.preventDefault();
              e.stopPropagation();
              return false;
            });
          break;
      }

      // Fix button click new tabs;
      $element.find('a').on('click.redir', function (e) {
        e.preventDefault();
        const $this = jQuery(this);
        const link = jQuery(this).attr('href');

        if (link && link != '') {
          // Show popup in editor
          if (link.indexOf('#show-') !== -1) {
            const id = link.split('#show-')[1];

            var $target = $gryffBody.find('#' + id);
            if ($target.length > 0) {
              // Show popup
              if ($target.attr('data-label') == 'Popup' && $target.data('gfmodule') != undefined) {
                var moduleId = $target.data('gfmodule').getModuleId();
                var moduleIdSlug = moduleId.toString().replace(/-/g, '');

                var func = 'getPopup' + moduleIdSlug;
                if (document.getElementById('gfFrame').contentWindow[func]) {
                  document.getElementById('gfFrame').contentWindow[func]().show();
                }
              }
            }
          }

          // Hide in Popup
          if (link.indexOf('#hide') !== -1) {
            var $target = $this.closest('[data-label="Popup"]');
            if ($target.length > 0) {
              // hide popup
              if ($target.attr('data-label') == 'Popup' && $target.data('gfmodule') != undefined) {
                var moduleId = $popup.data('gfmodule').getModuleId();
                var moduleIdSlug = moduleId.toString().replace(/-/g, '');

                var func = 'getPopup' + moduleIdSlug;
                if (document.getElementById('gfFrame').contentWindow[func]) {
                  document.getElementById('gfFrame').contentWindow[func]().hide();
                }
              }
            }
          }
        }

        return false;
      });
    };

    // gfElement.applyDrag
    this.applyDrag = function () {
      const $eHandle = $element.children('.gf-tool-wrap').find('.e-handle');

      $eHandle.gfDraggable({
        targetElement: $element,
        type: 'element',
        start: function () {
          $eHandle.closest('.gf-tool').removeClass('gf-expand');
          return false;
        },
        stop: function (nearY, $from, $to, $stElement, $dragHidden, notDragging) {
          // notDragging is usually undefinded
          // Xử lý cho trường hợp click event
          if (notDragging) {
            _this.openElementSettings(undefined, true);
            return;
          }
          // Xử lý cho drag event
          if (nearY != undefined) {
            const $newPlace = window.$gfPlaceHolders.eq(nearY.id);
            if ($newPlace.length === 1) {
              $to = $newPlace.closest('.item-content');

              const flag = true;

              // Hiện tại các Elm chưa thể chứa được content bên trong
              // // 6, Element chứa (P) không được kéo ra ngoài Product
              // if ($stElement && $from.closest('[data-label="Product"]').length > 0) {
              //     var $moduleElmProduct = $stElement.find('[data-label="(P) Title"], [data-label="(P) Description"], [data-label="(P) Price"], [data-label="(P) Quantity"], [data-label="(P) Cart Button"], [data-label="(P) Image"], [data-label="(P) Image List"], [data-label="(P) Variants"], [data-label="(P) Swatches"], [data-label="(P) Meta"]');
              //     if ($moduleElmProduct.length > 0) {
              //         if ($to.closest('[data-label="Product"]').length == 0) {
              //             flag = false;
              //             HELPER.showNotify('You cannot move product child elements out of Product module.', 'error');
              //         } else if(HELPER.isInsideTheList($to)) {
              //             flag = false;
              //             HELPER.showNotify('You cannot move product child elements out of Product module.', 'error');
              //         }
              //     }
              // }

              // // 7, Element chứa (A) không được kéo ra ngoài Article
              // if ($stElement && $from.closest('[data-label="Article"]').length > 0) {
              //     var $moduleElmArticle = $stElement.find('[data-label="(A) Title"], [data-label="(A) Image"], [data-label="(A) Content"], [data-label="(A) Date"]');
              //     if ($moduleElmArticle.length > 0) {
              //         if ($to.closest('[data-label="Article"]').length == 0) {
              //             flag = false;
              //             HELPER.showNotify('This module contains only fields that exist in the article', 'error');
              //         } else if(HELPER.isInsideTheList($to)) {
              //             flag = false;
              //             HELPER.showNotify('This module contains only fields that exist in the article', 'error');
              //         }
              //     }
              // }

              if (flag) {
                const $eHandle = $element.children('.gf-tool-wrap').find('.e-handle');
                $eHandle.data('gfdraggable').manageStop($newPlace, $stElement, $from, $to);
              }
            }
          } else {
            if ($dragHidden) {
              $dragHidden.after($stElement);
              window._isDetached = false;
            }
          }
          if ($dragHidden) {
            $dragHidden.remove();
          }
          _this.openElementSettings(undefined, true);
        },
      });
    };
    //TRUONGNC-NEW
    this.initElementErrorHighlight = function (errors) {
      const $toolHighlightWrapper = $element.children('.gf-error-wrapper');
      if ($toolHighlightWrapper.length == 0) {
        let wrapper = '<div class="gf-error-wrapper">';
        errors.forEach((error, index) => {
          const _eTool = `<div id=${error.id} class="gf-error-highlight gf-error-tool ${
            index === 0 ? 'gf-highlight-display' : ''
          }"><li class="t-handle"><a class="e-handle"><span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.86037 2.25123C8.47798 1.58293 7.52202 1.58292 7.13963 2.25122L1.13458 12.7463C0.752196 13.4146 1.23018 14.25 1.99495 14.25H14.0051C14.7698 14.25 15.2478 13.4146 14.8654 12.7463L8.86037 2.25123ZM7.99978 4.25613C8.27411 4.25613 8.49651 4.48053 8.49651 4.75735V9.26837C8.49651 9.54519 8.27411 9.7696 7.99978 9.7696C7.72544 9.7696 7.50304 9.54519 7.50304 9.26837V4.75735C7.50304 4.48053 7.72544 4.25613 7.99978 4.25613ZM7.99978 10.772C7.58827 10.772 7.25468 11.1087 7.25468 11.5239C7.25468 11.9391 7.58827 12.2757 7.99978 12.2757C8.41128 12.2757 8.74488 11.9391 8.74488 11.5239C8.74488 11.1087 8.41128 10.772 7.99978 10.772Z" fill="white"/></svg></span><span class="gf-tool-label">${
            error.name
          }</span></a></li></div>`;
          wrapper = wrapper + _eTool;
        });
        wrapper = wrapper + '</div>';
        $element.append(wrapper);
      } else {
        errors.forEach((error, index) => {
          const errorActive = $toolHighlightWrapper.find('.gf-error-highlight.gf-highlight-display');
          if ($toolHighlightWrapper.children(`#${error.id}`).length === 0) {
            const _eTool = `<div id=${error.id} class="gf-error-highlight gf-error-tool ${
              index === 0 && !errorActive ? 'gf-highlight-display' : ''
            }"><li class="t-handle"><a class="e-handle"><span><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.86037 2.25123C8.47798 1.58293 7.52202 1.58292 7.13963 2.25122L1.13458 12.7463C0.752196 13.4146 1.23018 14.25 1.99495 14.25H14.0051C14.7698 14.25 15.2478 13.4146 14.8654 12.7463L8.86037 2.25123ZM7.99978 4.25613C8.27411 4.25613 8.49651 4.48053 8.49651 4.75735V9.26837C8.49651 9.54519 8.27411 9.7696 7.99978 9.7696C7.72544 9.7696 7.50304 9.54519 7.50304 9.26837V4.75735C7.50304 4.48053 7.72544 4.25613 7.99978 4.25613ZM7.99978 10.772C7.58827 10.772 7.25468 11.1087 7.25468 11.5239C7.25468 11.9391 7.58827 12.2757 7.99978 12.2757C8.41128 12.2757 8.74488 11.9391 8.74488 11.5239C8.74488 11.1087 8.41128 10.772 7.99978 10.772Z" fill="white"/></svg></span><span class="gf-tool-label">${
              error.name
            }</span></a></li></div>`;
            $toolHighlightWrapper.append(_eTool);
          } else {
            index === 0 &&
              !errorActive &&
              $toolHighlightWrapper.children(`#${error.id}`).addClass('gf-highlight-display');
          }
        });
      }
    };
    //TRUONGNC-NEW
    this.removeHighlightTool = function (errorId) {
      const $outline = $element.children('.gf-error-outline');
      const $eToolWrapAfter = $element.children('.gf-error-wrapper');

      if (!errorId && $eToolWrapAfter) {
        $eToolWrapAfter.remove();
        $outline.remove();
        return;
      }
      const $errorElement = $eToolWrapAfter.find(`#${errorId}`);
      if ($errorElement) {
        $errorElement.remove();
      }
      const children = $eToolWrapAfter.children(`.gf-error-highlight`);
      if (children.length === 0) {
        $outline.remove();
      } else {
        this.setOffsetForHighlightTool();
      }
    };
    //TRUONGNC-NEW
    this.inactiveHighlightTool = function (errors, errorId) {
      console.log('TRUONGNC-RUNNING');
      const $eToolWrap = $element.children('.gf-error-wrapper');
      if (!$eToolWrap) {
        this.highLightTool(errors);
      }
      //gf-error-outline
      const $outline = $element.children('.gf-error-outline');

      const $eToolAfter = $element.find(`#${errorId}`);
      console.log('$eToolAfter:', $eToolAfter);
      $eToolAfter.addClass('inactive');
      $outline.addClass('inactive');
    };
    this.removeInactiveHighlightTool = function (errors, errorId) {
      const $eToolWrap = $element.children('.gf-error-wrapper');
      if (!$eToolWrap) {
        this.highLightTool(errors);
      }
      //gf-error-outline
      errors.forEach((item) => {
        if (item.id === errorId) {
          const $eToolAfter = $element.find(`#${errorId}`);
          $eToolAfter.removeClass('inactive');
          $eToolAfter.removeClass('hidden');
          $eToolAfter.addClass('gf-highlight-display');
        } else {
          const $eToolAfter = $element.find(`#${item.id}`);
          $eToolAfter.addClass('hidden');
          $eToolAfter.removeClass('gf-highlight-display');
        }
      });
      const $outline = $element.children('.gf-error-outline');

      $outline.removeClass('inactive');
    };
    //TRUONGNC-NEW
    this.setOffsetForHighlightTool = function () {
      const $eToolWrap = $element.children('.gf-error-wrapper');
      if ($eToolWrap.length > 0) {
        const eClass = _this.getTargetClass();
        const elementName = $element.attr('data-label');
        var $self = $element.find(eClass);
        const editorHeight = $eToolWrap.height();
        const editorWidth = $eToolWrap.width();
        const fST = $gfFrame.contents().scrollTop();
        const offset = $self.offset();
        const toolOffset = 20; // MERs's tools offset

        if (eClass != '' && elementName !== 'Text Block') {
          var top = 0 + $self.height() / 2;
          // if (offset.top + top - editorHeight / 2 < fST) {
          //   top = fST - offset.top + toolOffset;
          // }
          $eToolWrap.css({
            top: top,
          });
        } else if (elementName == 'Text Block') {
          if ($self.outerHeight() < 500) {
            var top = 0 + $self.outerHeight() / 2;
          } else {
            var top = 8;
          }

          if (offset.top < fST) {
            top = fST - offset.top + toolOffset;
          }
          $eToolWrap.css({
            top: top,
          });
          const _top = top;
          const _iframeContent = $gfFrame.contents();
          $(_iframeContent)
            .off('scroll.toolTextBlock')
            .on('scroll.toolTextBlock', function (e) {
              const _topScroll = _iframeContent.scrollTop();
              if (offset.top < _topScroll) {
                top = _topScroll - offset.top + toolOffset;
              } else {
                top = _top;
              }
              $eToolWrap.addClass('gf-tool-show');
              $eToolWrap.css({
                top: top,
              });
              return;
            });
        }
      }
    };

    this.handleHiddenErrorHighlight = function (isHidden) {
      const $eToolWrap = $element.children('.gf-error-wrapper');
      const $outline = $element.children('.gf-error-outline');
      if ($eToolWrap) {
        isHidden ? $eToolWrap.addClass('gf-tool-hidden') : $eToolWrap.removeClass('gf-tool-hidden');
      }
      if ($outline) {
        isHidden ? $outline.addClass('hidden') : $outline.removeClass('hidden');
      }
    };

    //TRUONGNC-NEW
    this.highLightTool = function (errors) {
      let showTool = true;
      // handle disable here
      // if it is hoving ==> disable
      this.initElementErrorHighlight(errors);
      const showOutline = true;

      if (showTool) {
        const $eToolWrap = $element.children('.gf-error-wrapper');

        $eToolWrap.addClass('gf-tool-show');

        const eClass = _this.getTargetClass();
        var $self = $element.find(eClass);

        const size = $gfResTool.data('gfrestool')?.getCurrentStatus();
        const elementName = $element.attr('data-label');
        const elementKey = $element.attr('data-key');

        // Resize LEFT;
        if (eClass != '') {
          const $elm = $element.children('.elm');
          var $self = $element.find(eClass);

          if ($elm.hasClass('gf-elm-left-' + size)) {
            if (elementKey == 'checkbox') {
              // let realWidth = 0;
              // $self.parent().children().each((___i, child) => {
              //     realWidth += jQuery(child).outerWidth();
              // })
              const realWidth = $self.parent().outerWidth();
              var left = 0 + realWidth / 2;
              $eToolWrap.css('left', left);
            } else {
              var left = 0 + $self.outerWidth() / 2;
              $eToolWrap.css('left', left);
            }
          } else if ($elm.hasClass('gf-elm-center-' + size)) {
            var left = $element.outerWidth() / 2;
            $eToolWrap.css('left', left);
          } else if ($elm.hasClass('gf-elm-right-' + size)) {
            if (elementKey == 'checkbox') {
              // let realWidth = 0;
              // $self.parent().children().each(child => {
              //     realWidth += jQuery(child).outerWidth();
              // })
              const realWidth = $self.parent().outerWidth();
              var left = $element.outerWidth() - realWidth / 2;
              $eToolWrap.css('left', left);
            } else {
              var left = $element.outerWidth() - $self.outerWidth() / 2;
              $eToolWrap.css('left', left);
            }
          } else {
            var left = $element.outerWidth() / 2;
            $eToolWrap.css('left', left);
          }
        } else {
          var left = $element.outerWidth() / 2;
          $eToolWrap.css('left', left);
        }

        // Resize top;
        const editorHeight = $eToolWrap.height();
        const editorWidth = $eToolWrap.width();
        const fST = $gfFrame.contents().scrollTop();
        const offset = $self.offset();
        const toolOffset = 20; // MERs's tools offset
        if (eClass != '' && elementName !== 'Text Block') {
          var top = 0 + $self.height() / 2;
          // if (offset.top + top - editorHeight / 2 < fST) {
          //   top = fST - offset.top + toolOffset;
          // }

          // $eToolWrap.css({
          //   top: top,
          // });
        } else if (elementName == 'Text Block') {
          if ($self.outerHeight() < 500) {
            var top = 0 + $self.outerHeight() / 2;
          } else {
            var top = 8;
          }

          if (offset.top < fST) {
            top = fST - offset.top + toolOffset;
          }
          $eToolWrap.css({
            top: top,
          });
          const _top = top;
          const _iframeContent = $gfFrame.contents();
          $(_iframeContent)
            .off('scroll.toolTextBlock')
            .on('scroll.toolTextBlock', function (e) {
              const _topScroll = _iframeContent.scrollTop();
              if (offset.top < _topScroll) {
                top = _topScroll - offset.top + toolOffset;
              } else {
                top = _top;
              }
              $eToolWrap.addClass('gf-tool-show');
              $eToolWrap.css({
                top: top,
              });
              return;
            });
        }
      }
      console.log('GF-OUT-LIGHT', $element.data('gfoutline'), showOutline);
      if ($element.data('gfoutline') != undefined && showOutline) {
        $element.data('gfoutline').showErrorOutline();
      }
      return false;
    };

    // gfElement.showTool
    this.showTool = function (force, enableTool) {
      let showTool = true;
      if ($element.attr('data-tool') == '0') {
        showTool = false;
      }
      if ($element.attr('data-resize') == 'true') {
        showTool = false;
      }
      if (!force) {
        if ($gryffEditor.data('gryffeditor').isDragging() || $gryffEditor.data('gftexteditor').isEditing($element)) {
          showTool = false;
        }
      } else {
        showTool = true;
      }

      if (enableTool != undefined) {
        showTool = enableTool;
      }

      const showOutline = true;

      if (showTool) {
        const $eToolWrap = $element.children('.gf-e-tool-wrap');
        $eToolWrap.addClass('gf-tool-show');
        $eToolWrap.removeClass('gf-tool-hidden');
        const eClass = _this.getTargetClass();
        var $self = $element.find(eClass);

        const size = $gfResTool.data('gfrestool')?.getCurrentStatus();
        const elementName = $element.attr('data-label');
        const elementKey = $element.attr('data-key');

        // Resize LEFT;
        if (eClass != '') {
          const $elm = $element.children('.elm');
          var $self = $element.find(eClass);

          if ($elm.hasClass('gf-elm-left-' + size)) {
            if (elementKey == 'checkbox') {
              // let realWidth = 0;
              // $self.parent().children().each((___i, child) => {
              //     realWidth += jQuery(child).outerWidth();
              // })
              const realWidth = $self.parent().outerWidth();
              var left = 0 + realWidth / 2;
              $eToolWrap.css('left', left);
            } else {
              var left = 0 + $self.outerWidth() / 2;
              $eToolWrap.css('left', left);
            }
          } else if ($elm.hasClass('gf-elm-center-' + size)) {
            var left = $element.outerWidth() / 2;
            $eToolWrap.css('left', left);
          } else if ($elm.hasClass('gf-elm-right-' + size)) {
            if (elementKey == 'checkbox') {
              // let realWidth = 0;
              // $self.parent().children().each(child => {
              //     realWidth += jQuery(child).outerWidth();
              // })
              const realWidth = $self.parent().outerWidth();
              var left = $element.outerWidth() - realWidth / 2;
              $eToolWrap.css('left', left);
            } else {
              var left = $element.outerWidth() - $self.outerWidth() / 2;
              $eToolWrap.css('left', left);
            }
          } else {
            var left = $element.outerWidth() / 2;
            $eToolWrap.css('left', left);
          }
        } else {
          var left = $element.outerWidth() / 2;
          $eToolWrap.css('left', left);
        }

        // Resize top;
        const editorHeight = $eToolWrap.height();
        const editorWidth = $eToolWrap.width();
        const fST = $gfFrame.contents().scrollTop();
        const offset = $self.offset();
        const toolOffset = 20; // MERs's tools offset
        if (eClass != '' && elementName !== 'Text Block') {
          var top = 0 + $self.height() / 2;
          if (offset.top + top - editorHeight / 2 < fST) {
            top = fST - offset.top + toolOffset;
          }

          // $eToolWrap.css({
          //   top: top,
          // });
        } else if (elementName == 'Text Block') {
          if ($self.outerHeight() < 500) {
            var top = 0 + $self.outerHeight() / 2;
          } else {
            var top = 8;
          }

          if (offset.top < fST) {
            top = fST - offset.top + toolOffset;
          }
          $eToolWrap.css({
            top: top,
          });
          const _top = top;
          const _iframeContent = $gfFrame.contents();
          $(_iframeContent)
            .off('scroll.toolTextBlock')
            .on('scroll.toolTextBlock', function (e) {
              const _topScroll = _iframeContent.scrollTop();
              if (offset.top < _topScroll) {
                top = _topScroll - offset.top + toolOffset;
              } else {
                top = _top;
              }
              $eToolWrap.addClass('gf-tool-show');
              $eToolWrap.css({
                top: top,
              });
              return;
            });
        }
      }
      if ($element.data('gfoutline') != undefined && showOutline) {
        $element.data('gfoutline').showOutline();
      }
      this.handleHiddenErrorHighlight(true);
      return false;
    };

    // gfElement.hideTool
    this.hideTool = function (force) {
      if (
        !window._isContextOpenned ||
        ($gryffBody.data('gfcontextmenu') &&
          $gryffBody.data('gfcontextmenu').getTargetMERId() != $element.attr('id')) ||
        force == true
      ) {
        if (!$gryffEditor.data('gryffeditor').isDragging() || force) {
          const $eToolWrap = $element.children('.gf-e-tool-wrap');
          // $eToolWrap.addClass('gf-tool-hidden');
          $eToolWrap.removeClass('gf-tool-show');
          const _iframeContent = $gfFrame.contents();
          $(_iframeContent).off('scroll.toolTextBlock');

          if ($element.data('gfoutline') != undefined) {
            $element.data('gfoutline').hideOutine();
          }
        }
      }
      $element.removeClass('gf_primary-tool');
      this.handleHiddenErrorHighlight(false);
      return false;
    };

    this.applyButtonActions = function () {
      //Edit element
      const $eToolWrap = $element.children('.gf-tool-wrap');

      // effect click title
      $eToolWrap
        .find('.t-handle .gf-tool-label')
        .off('mousedown.scale')
        .on('mousedown.scale', function () {
          $eToolWrap.addClass('gf-tool-active');
          setTimeout(function () {
            $eToolWrap.removeClass('gf-tool-active');
          }, 100);
        });

      // action buttons
      $eToolWrap
        .find('.t-collapse > a')
        .off('click')
        .on('click', function () {
          const $tool = jQuery(this).closest('.gf-tool');
          const elementName = $element.attr('data-label');
          if ($tool.hasClass('gf-expand')) {
            $tool.removeClass('gf-expand');
          } else {
            $tool.addClass('gf-expand');
          }
          return false;
        });

      $eToolWrap
        .find('.e-edit')
        .off('click')
        .on('click', function (e) {
          e.preventDefault();
          _this.hideTool();
          const elementName = $element.attr('data-label');
          if (elementName == 'Heading' || elementName == 'Text Block') {
            $gryffEditor.data('gftexteditor').onFocus($element);
          }
          return false;
        });

      $eToolWrap
        .find('.e-export')
        .off()
        .on('click', async function () {
          await handleAddToLibrary($element);
          return false;
        });
      $eToolWrap
        .find('.e-clone')
        .off()
        .on('click', function () {
          _this.cloneMe();
          return false;
        });
      $eToolWrap
        .find('.e-remove')
        .off()
        .on('click', function () {
          $element.fadeOut(300, function () {
            _this.doRemoveMe();

            // go back to tab 0
            $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
          });
          return false;
        });
    };
    this.getKeyDataSetting = function (keyType, elementId, type = 'element') {
      const key = `${keyType}-${type}-${elementId}`;
      return key;
    };

    this.init();
  };

  jQuery.fn.gfElement = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfelement')) {
        const plugin = new jQuery.gfElement(this, options);
        jQuery(this).data('gfelement', plugin);
      }
    });
  };
})(jQuery);
